module.exports = {
  'header': {
    'text1': '飞行平台',
    cpList: [
      {
        title: '无人直升机',
        list: [
          {
            name: 'HW-600H',
            router: '/hw600'
          },
          {
            name: 'HW-25H',
            router: '/hw25h'
          }
        ]
      },
      {
        title: '复合翼无人机',
        list: [
          {
            name: 'ZT-120V',
            router: '/zt120v'
          },
          {
            name: 'ZT-60VS',
            router: '/zt60vs'
          },
          {
            name: 'ZT-60V',
            router: '/zt60v'
          },
          {
            name: 'ZT-25VS',
            router: '/zt25vs'
          },
          {
            name: 'ZT-25V',
            router: '/zt25v'
          },
          {
            name: 'ZT-16V',
            router: '/zt16v'
          },
          {
            name: 'ZT-13V',
            router: '/zt13v'
          }
        ]
      }
    ],
    routerList1:[
      {
        title:'任务载荷',
        list:[
          {
            name: '光电吊舱',
            router: '/gddc'
          },
          {
            name: '测绘相机',
            router: '/chxj'
          },
          {
            name: '激光雷达',
            router: '/jgld'
          }
        ]
      },
      {
        title:'地面设备',
        list:[
          {
            name: '便携操控站',
            router: '/dmsb'
          },
          {
            name: '双屏操控站',
            router: '/dmsb2'
          },
          {
            name: '漫游数据链',
            router: '/dmsb3'
          },
          {
            name: '中继数据链',
            router: '/dmsb4'
          }
        ]
      },
      {
        title:'软件产品',
        list:[
          {
            name: '巡检助手',
            router: '/rjcp'
          },
          {
            name: 'Dowell',
            router: '/rjcp2'
          },
          {
            name: '云巡',
            router: '/rjcp3'
          }
        ]
      },
    ],
    routerList2:[
      {
        title:'模拟仿真',
        list:[
          {
            name: '模拟仿真训练器',
            router: '/fzxt'
          },
        ]
      },
      {
        title:'无人机场',
        list:[
          {
            name: '云巡无人值守系统',
            router: '/yxxt'
          },
        ]
      },
      {
        title:'',
        list:[]
      },
    ],
    'list': [
      {
        'title': '行业方案',
        'id': '1',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '5-2',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'After Sales',
              'alias': '应急',
              'link': '/fayj',
              'discription': ''
            },
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '能源',
              'link': '/fany',
              'discription': ''
            },
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '林草',
              'link': '/falc',
              'discription': ''
            },
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '公安',
              'link': '/faga',
              'discription': ''
            },
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '测绘',
              'link': '/fach',
              'discription': ''
            },
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '水利',
              'link': '/fasl',
              'discription': ''
            }
          ]
        }
      },
      {
        'id': '2',
        'title': '产品中心',
        'children': {
          'list': []
        }
      },
      {
        'id': '7',
        'title': '新闻动态',
        'target': 'self',
        'link': '/hyxw',
      },
      {
        'title': '关于我们',
        'id': '5',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '5-1',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'About',
              'alias': '公司简介',
              'link': '/join',
              'discription': '公司简介'
            },
            {
              'id': '5-2',
              'parentMenuId': '5',
              'state': 'TEXT',
              'name': 'After Sales',
              'alias': '加入我们',
              'link': '/join2',
              'discription': '企业介绍'
            }
          ]
        }
      },
      {
        'id': '6',
        'title': '联系我们',
        'target': 'self',
        'link': '/contactUs'
      }
    ],
    'listM': [
      {
        'title': '行业方案',
        'id': '2',
        'children': {
          'isHv': 0,
          'list': [
            {
              'title': '方案',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '应急',
                  'alias': '应急',
                  'link': '/fayj',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '能源',
                  'alias': '能源',
                  'link': '/fany',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '林草',
                  'alias': '林草',
                  'link': '/falc',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '公安',
                  'alias': '公安',
                  'link': '/faga',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '测绘',
                  'alias': '测绘',
                  'link': '/fach',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '水利',
                  'alias': '水利',
                  'link': '/fasl',
                  'img': '',
                  'discription': ''
                },
              ]
            }
          ]
        }
      },
      {
        'title': '产品中心',
        'id': '2',
        'children': {
          'isHv': 0,
          'list': [
            {
              'title': '无人直升机',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'HW-600H',
                  'alias': 'HW-600H',
                  'link': '/hw600',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'HW-25H',
                  'alias': 'HW-25H',
                  'link': '/hw25h',
                  'img': '',
                  'discription': ''
                },
              ]
            },
            {
              'title': '复合翼无人机',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'ZT-120V',
                  'alias': 'ZT-120V',
                  'link': '/zt120v',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'ZT-60VS',
                  'alias': 'ZT-60VS',
                  'link': '/zt60vs',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'ZT-60V',
                  'alias': 'ZT-60V',
                  'link': '/zt60v',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'ZT-25VS',
                  'alias': 'ZT-25VS',
                  'link': '/zt25vs',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'ZT-25V',
                  'alias': 'ZT-25V',
                  'link': '/zt25v',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'ZT-16V',
                  'alias': 'ZT-16V',
                  'link': '/zt16v',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'ZT-13V',
                  'alias': 'ZT-13V',
                  'link': '/zt13v',
                  'img': '',
                  'discription': ''
                },
              ]
            },
            {
              'title': '任务载荷',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '光电吊舱',
                  'alias': '光电吊舱',
                  'link': '/gddc',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '测绘相机',
                  'alias': '测绘相机',
                  'link': '/chxj',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '激光雷达',
                  'alias': '激光雷达',
                  'link': '/jgld',
                  'img': '',
                  'discription': ''
                },
              ]
            },
            {
              'title': '地面设备',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '便捷操控站',
                  'alias': '便携操控站',
                  'link': '/dmsb',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '双屏操控站',
                  'alias': '双屏操控站',
                  'link': '/dmsb2',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '漫游数据链',
                  'alias': '漫游数据链',
                  'link': '/dmsb3',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '中继数据链',
                  'alias': '中继数据链',
                  'link': '/dmsb4',
                  'img': '',
                  'discription': ''
                },
              ]
            },
            {
              'title': '软件产品',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '巡检助手',
                  'alias': '巡检助手',
                  'link': '/rjcp',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': 'Dowell',
                  'alias': 'Dowell',
                  'link': '/rjcp2',
                  'img': '',
                  'discription': ''
                },
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '云巡',
                  'alias': '云巡',
                  'link': '/rjcp3',
                  'img': '',
                  'discription': ''
                },
              ]
            },
            {
              'title': '模拟仿真',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '模拟仿真训练器',
                  'alias': '模拟仿真训练器',
                  'link': '/fzxt',
                  'img': '',
                  'discription': ''
                },
              ]
            },
            {
              'title': '无人机场',
              'state': 'SORT',
              'list': [
                {
                  'id': '2-2',
                  'parentMenuId': '2',
                  'name': '云巡无人值守系统',
                  'alias': '云巡无人值守系统',
                  'link': '/yxxt',
                  'img': '',
                  'discription': ''
                },
              ]
            },
          ],
        },
      },
      {
        'title': '新闻动态',
        'id': '6',
        'target': 'self',
        'link': '/hyxw'
      },
      {
        'title': '关于我们',
        'id': '7',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '6-1',
              'parentMenuId': '6',
              'state': 'TEXT',
              'name': 'Campus',
              'alias': '公司简介',
              'link': '/join',
              'discription': '公司简介'
            },
            {
              'id': '6-2',
              'parentMenuId': '6',
              'state': 'TEXT',
              'name': 'Social',
              'alias': '加入我们',
              'link': '/join2',
              'discription': '加入我们'
            }
          ]
        }
      },
      {
        'title': '联系我们',
        'id': '7',
        'state': 'TEXT',
        'link': '/contactUs',
        'discription': '联系我们',
      },
      {
        'title': '中文/EN',
        'id': '8',
        'children': {
          'isHv': 0,
          'list': [
            {
              'id': '8-1',
              'parentMenuId': '6',
              'state': 'OTHER',
              'alias': '中文',
              'discription': 'zh_CN'
            },
            {
              'id': '8-2',
              'parentMenuId': '6',
              'state': 'OTHER',
              'alias': 'EN',
              'discription': 'en_US'
            }
          ]
        }
      }
    ],
    'assistInfo': {
      'lang': 'CN',
      'login': 'login',
      'register': 'register',
      'href': '/'
    }
  },
  'footer': [
    {
      'titleZH': '走进航翊',
      'titleEN': 'Contact us',
      'children': [
        // {
        //   'name': '关于我们',
        //   'target': 'self',
        //   'href': '/about-us'
        // },
        {
          'name': '公司简介',
          'target': 'self',
          'href': '/join'
        },
        {
          'name': '联系我们',
          'target': 'self',
          'href': '/contactUs'
        }
      ]
    },
    {
      'titleZH': '技术支持',
      'titleEN': 'Support',
      'children': [
        {
          'name': '帮助与支持',
          'target': 'self',
          'href': '/after-sale'
        }
      ]
    },
    {
      'titleZH': '加入我们',
      'titleEN': 'Join us',
      'children': [
        {
          'name': '加入我们',
          'target': 'self',
          'href': '/join2'
        },
      ]
    }
  ],
  'foot1': {
    'text1': '售后电话',
    'text2': '业务咨询',
  },
  // caogt添加

  'com_banner': {
    "banner": [
      {
        neme1:'无人直升机',
        text1:'HW-600H',
        neme2:'载重',
        text2:'200+kg',
        neme3:'续航',
        text3:'8h',
        neme4:'图传',
        text4:'300km',
        info:'HW-600H\n' +
          '          是一款大载重长航时运输型无人直升机，动力系统采用自主可控油动发动机，机身采用纵列式布局，结构紧凑、载重效率高，航电设备采用三余度安全飞控，具备卫星导航和视觉融合导航双重导航体系，结合基于激光雷达的自主避障系统，全面保障飞行安全。',
        "url": "/static/images/v2/600h/600h_bg1.png",
        "h5url": "/static/images/v2/600h/600h_bg1.png",
        "color": "#fff",
        href:'hw600'
      },
      {
        neme1:'油电混动垂直起降固定翼无人机',
        text1:'ZT-120V',
        neme2:'载荷能力',
        text2:'40kg',
        neme3:'续航',
        text3:'10h',
        neme4:'可扩展控制范围',
        text4:'300+km',
        info:' ZT-120V无人机是专为航空应急救援场景研发的行业领先产品，采用固定翼与多旋翼结合的复合翼布局。该无人机适配全套的应急场景载荷，可快速完成空中侦察和通信保障工作，具备全天候三维建模和快速成图能力，为应急救援工作提供强有力的支持和保障。',
        "url": "/static/images/v2/120v/120v_bg1.png",
        "h5url": "/static/images/v2/120v/120v_bg1.png",
        "color": "#fff",
        href:'/zt120v'
      },
      {
        neme1:'复合翼无人机',
        text1:'ZT-13V',
        neme2:'',
        text2:'',
        neme3:'载荷能力',
        text3:'3kg',
        neme4:'续航',
        text4:'200min',
        info:'ZT-13V采用纯电驱动方式，载荷能力3kg，续航时间200分钟，最大航程180km，是一款专门适用于无人机场的无人机',
        "url": "/static/images/v2/13v/13v_bg1.png",
        "h5url": "/static/images/v2/13v/13v_bg1.png",
        "color": "#fff",
        href:'/zt13v'
      },
    ]
  },
  'com_meters': {
    'text1': '解决方案定制专家',
    'text2': '查看',
    'text3': '关闭',
  },
  'com_application': {
    'list': [
      {
        'label': "警用",
        'img': "/static/images/industry/application/1.png"
      },
      {
        'label': "测绘",
        'img': "/static/images/industry/application/2.png"
      },
      {
        'label': "石油",
        'img': "/static/images/industry/application/3.png"
      },
      {
        'label': "电力",
        'img': "/static/images/industry/application/4.png"
      },
      {
        'label': "应急",
        'img': "/static/images/industry/application/5.png"
      },
      {
        'label': "环保",
        'img': "/static/images/industry/application/6.png"
      },
      {
        'label': "海事",
        'img': "/static/images/industry/application/7.png"
      }
    ]
  },

  'about_after': {
    'help': '帮助与支持'

  },
  'about_company': {
    'name-1': '公司简介',
    'name': '航翊科技',
    'intro': '北京航翊科技有限公司（以下简称“航翊科技”或“公司”）专注于大载重无人直升机的研发与生产，致力于为客户提供专业的无人直升机行业解决方案。',
    'title1': '15年+核心技术积累',
    'title2': '芯片级无人机研发和量产能力',
    'title3': '全产业链整合能力',
    'title4': '十数年技术研发积累',
    'title5': '专注于无人机实用技术研究和推广',
    'desc1': '创始团队从事无人机行业十五年以上，专注于飞控、数据链、载荷、机器视觉等关键技术，拥有技术优势',
    'desc2': '团队是行业内唯二累计生产销售无人机超20万架，具备芯片级无人机研发和量产能力',
    'desc3': '无人机关键技术全部自主研发，具备全产业链整合能力',
    'desc4': '航翊科技自主掌握',
    'desc5': '飞行控制系统、光电吊舱（EO/IR）、远程数据链、AI机器视觉',
    'desc6': '等关键核心技术。公司已形成无人直升机专用航电产品、大载重直升机等多类成熟型产品线，核心产品大载重无人直升机高度集成多项无人机技术，具备大载重、长续航、挂点多、投送手段丰富、装载空间大、长时间悬停能力等优势，较同类型产品性能更强大，成本更低，性价比高，可广泛应用于物资运输、应急、电力、边防、石油等多个领域。公司目前已经具备政府、央企、海外等多个稳定客户，市场稳定增长。',
  },
  'about_contact': {
    'tell_me': '告诉我们您的需求',
    'text1': '您可通过以下联系方式告诉我们您的需求，我们的销售经理/技术顾问将会针对您的需求为您提供最适合您的专业帮助。',
    'text2': '创新业务',
    'text3': '能源、军用、科研等工业无人机前沿应用探索和运营托管服务等',
    'text4': '公司地址',
    'text5': '航翊科技',
    'text6': '北京市海淀区华胜天成科研大楼一层东侧101-102',
  },
  'about_index': {
    'text1': '关于我们',
    'text2': '走进航翊科技',
    'text3': '航翊科技由一群“有梦想、有活力、有激情、勇于创新”的年轻人组成',
    'text4': '航翊科技致力于“用无人机和人工智能技术赋能产业应用”',
    'text4-1': '推动生产方式革新发展',
    'text5': '专注于大载重无人直升机的技术研究与推广',
    'text5-1': '专注于无人机实用技术研究和推广',
    'text6': '进一步了解，我们的技术和研发积累',
    'text7': '技术版图和研发积累',
    'text8': '“尊重、包容、发展”',
    'text9': '努力为每一位加入我们的优秀人才提供施展才华的平台和实现人生价值、梦想的舞台',
    'text10': '“匠心、务实、创新”',
    'text11': '秉持“匠心 务实 创新”的企业理念，从用户的真实需求出发，积极探索无人机在社会生产中的广阔应用场景和无限可能，致力于用最前沿的无人机和人工智能技术赋能行业应用，推动生产方式的持续革新发展。',
    'text12': '走进航翊',
    'list': [
      {
        'title': "研发",
        'desc': "无人机产品、解决方案和关键技术研发",
        'img': "/static/images/about/about/yanfa.png",
        'alt': "研发"
      },
      {
        'title': "销售",
        'desc': "无人机整机产品、航电系统和载荷销售",
        'img': "/static/images/about/about/xiaoshou.png",
        'alt': "销售"
      },
      {
        'title': "服务",
        'desc': "无人机业务托管运营和综合技术服务",
        'img': "/static/images/about/about/fuwu.png",
        'alt': "服务"
      },
      {
        'title': "ODM",
        'desc': "无人机产品需求定制和ODM生产",
        'img': "/static/images/about/about/ODM.png",
        'alt': "ODM"
      }
      // {
      //   title: "编队",
      //   desc: "无人机编队表演和技术方案输出",
      //   img: "/static/images/about/about/biandui.png",
      //   alt: "编队"
      // }
    ]
  },
  //--------------
  'avionics_diatal': {
    'text1': '数图一体数据链',
    'text2': '体积小 重量轻 远距离传输 低延迟',
    'text3': '多路合一，灵活扩展',
    'text4': '可同时接入图像链路、数据链路、差分GPS校正链路、S-BUS链路等，灵活扩展，功能强大。',
    'text5': '专用视频 低功率 高效率',
    'text6': '1.4GHz无人机专用频率，传输距离可达30Km,功率低至0.5W,符合工业和信息部无人机驾驶航空器系统频率规定。',
    'text7': '高清成像，视若亲临',
    'text8': '搭载的可见光摄像机具备30倍光学变焦能力，高清成像，突破视觉束缚。',
    'text9': '高清画质 纤毫毕现',
    'text10': 'HDMI高清信号输入，H.264图像压缩方式，',
    'text11': '应用范围广泛',
    'text12': '可用于遥感航测、海事巡航、电力巡航、高速公路检测、边防巡逻、森林防火、环境检测、农业气象、军事侦察、管道巡检、城市应急等领域。',
    'text13': '解决方案定制专家',
    'text14': '查看',
    'text15': '关闭',
    'text16': '销售热线：010-58650999',
    'text17': '邮箱：public@aeronitor.com',
  },
  'avionics_gimbal': {
    'applicationTitle': "适用多型无人载具",
    'tel': "孔先生：13240113344（微信同号）",
    'email': "邮箱：public@aeronitor.com",
    'text1': 'HW-Gimbal系列光电吊舱',
    'text2': '专注为各型高阶无人机提供完整解决方案',
    'text3': 'HW-Gimbal系列光电吊舱专为高阶无人机平台研制，集成先进的驱动控制算法，采用三轴机械增稳技术，增稳精度±0.02°，搭配机载AI人工智能模块可实现对移动目标的快速检测和稳定跟踪，根据应用场景HW-Gimbal系统光电吊舱集成了包括可见光、热红外、激光等光电单元，可拓展PAD操控终端和双屏地面站，广泛适用于侦查取证、应急救援、线路巡检、边防巡逻等无人机空中作业场景。',
    'text4': 'HW-Gimbal系列光电吊舱特色优点',
    'text5': '产品参数',
    'text6': '查看',
    'text7': '关闭',
    'text8': 'HW-Gimbal系列光电吊舱 (部分)',
    'applyData': [
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "三轴机械增稳，始终稳定",
        'desc': "集成先进的驱动控制算法，采用三轴机械增稳技术，巡航增稳精度±0.02°，任何角度都能保持视场水平稳定；",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "三轴机械增稳，始终稳定"
      },
      {
        'type': '0',
        'title': "低风阻球形外观，横滚轴45°下倾",
        'desc': "采用低风阻球形外观，隐藏式框架设计，创新采用横滚轴下倾45°结构设计，最大限度贴合无人机巡航姿态；",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "低风阻球形外观，横滚轴45°下倾"
      },
      {
        'type': '0',
        'title': "自主原创，体积小、重量轻，广泛适用",
        'desc': "自主原创研发，拥有完整知识产权，轻量化结构设计，具有体积小，重量轻，广泛适用的优点；",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "自主原创，体积小、重量轻，广泛适用"
      },
      {
        'type': '0',
        'title': "支持拓展AI人工智，赋能高效生产力",
        'desc': "支持拓展机载端AI人工智能模块，实现AI目标智能识别、目标锁定自动追踪、AR数据实时叠加等，赋能高效生产力；",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "支持拓展AI人工智，赋能高效生产力"
      },
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "兼容性好，可拓展高阶航电完整解决方案",
        'desc': "兼容性好，支持第三方航电，可拓展高阶航电完整解决方案，性价比高，还可实现在卫星拒止条件下正常作业；",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "兼容性好，可拓展高阶航电完整解决方案"
      },
      {
        'type': '0',
        'title': "支持定制化开发，实现更多可能",
        'desc': "支持定制化光电单元和手持PAD操控终端，兼容多种数据链，满足个性化定制需求，广泛适用；",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "支持定制化开发，实现更多可能"
      }
    ],
    'tb_txt1': '产品型号',
    'tb_txt2': 'G10T-30X',
    'tb_txt3': 'G20T-30X35',
    'tb_txt4': 'G30T-30X35L10',
    'tb_txt5': '尺寸|重量',
    'tb_txt6': '直径100mm；高154mm；重530g',
    'tb_txt7': '直径110mm；高160.7mm；重630g',
    'tb_txt8': '直径122mm；高172.4mm；重660g',
    'tb_txt9': '功耗',
    'tb_txt10': '常规≤11.5W，峰值≤43W',
    'tb_txt11': '常规≤11.7W，峰值≤49W',
    'tb_txt12': '常规≤9.8W，峰值≤49W',
    'tb_txt13': '增稳类型',
    'tb_txt14': '三轴机械增稳',
    'tb_txt15': '三轴机械增稳',
    'tb_txt16': '三轴机械增稳',
    'tb_txt17': '俯仰|航向|横滚',
    'tb_txt18': '+45°~-135° | 360°xn | +60°~-60°',
    'tb_txt19': '+45°~-135° | 360°xn | +60°~-60°',
    'tb_txt20': '+45°~-135° | 360°xn | +60°~-60°',
    'tb_txt21': '增稳性能',
    'tb_txt22': '±0.02°',
    'tb_txt23': '±0.02°',
    'tb_txt24': '±0.02°',

    'tb_txt25': '可见光',
    'tb_txt26': '镜头',
    'tb_txt27': '30x光变；焦距4.3~129mm；F1.6~4.7',
    'tb_txt28': '30x光变；焦距4.3~129mm；F1.6~4.7',
    'tb_txt29': '30x光变；焦距4.3~129mm；F1.6~4.7',
    'tb_txt30': '传感器',
    'tb_txt31': '索尼星光级CMOS',
    'tb_txt32': '索尼星光级CMOS',
    'tb_txt33': '索尼星光级CMOS',
    'tb_txt34': '影像',
    'tb_txt35': 'FHD，1080P@30fps',
    'tb_txt36': 'FHD，1080P@30fps',
    'tb_txt37': 'FHD，1080P@30fps',
    'tb_txt38': 'FOV',
    'tb_txt39': '63.7°(广角端)至2.3°(长焦端)',
    'tb_txt40': '63.7°(广角端)至2.3°(长焦端)',
    'tb_txt41': '63.7°(广角端)至2.3°(长焦端)',

    'tb_txt42': '热红外',
    'tb_txt43': '分辨率',
    'tb_txt44': '一 一',
    'tb_txt45': '640x512，12μm像元',
    'tb_txt46': '640x512，12μm像元',
    'tb_txt47': '类型',
    'tb_txt48': '一 一',
    'tb_txt49': '非制冷氧化钒焦平面阵列8~14μm',
    'tb_txt50': '非制冷氧化钒焦平面阵列8~14μm',
    'tb_txt51': '焦距',
    'tb_txt52': '一 一',
    'tb_txt53': '35mm',
    'tb_txt54': '35mm',
    'tb_txt55': 'FOV',
    'tb_txt56': '一 一',
    'tb_txt57': 'HFOV12.5°，VFOV10°，DFOV16°',
    'tb_txt58': 'HFOV12.5°，VFOV10°，DFOV16°',

    'tb_txt59': '激光测距',
    'tb_txt60': '波长',
    'tb_txt61': '一 一',
    'tb_txt62': '一 一',
    'tb_txt63': '900~908nm (人眼安全)',
    'tb_txt64': '测量范围',
    'tb_txt65': '一 一',
    'tb_txt66': '一 一',
    'tb_txt67': '3.5~1000m',
    'tb_txt68': '测量精度',
    'tb_txt69': '一 一',
    'tb_txt70': '一 一',
    'tb_txt71': '1m',
    'tb_txt72': '接口',
    'tb_txt73': '视频输出:SDI-OUT; 吊舱控制:CAN、S-BUS、R232; 跟踪模块:SDI-N、AV-N、HDMI-OUT、SDI-OUT、USB',
    'tb_txt74': '环境适应',
    'tb_txt75': '工作温度: -20°C~55°C； 存储温度: -20°C~60°C;',
    'tb_txt76': '获取更多HW-Gimbal系列光电吊舱产品信息，请与我们联系',

  },
  'avionics_gimbalSpecial': {
    'text1': 'HW-Gimbal特种光电吊舱',
    'text2': '专注为各型高阶无人机提供完整解决方案',
    'text3': 'HW-Gimbal特种光电吊舱，采用多框架三轴机械增稳结构，集成先进的驱动控制算法，为专业载荷性能发挥提供极致稳定保障，可拓展机载AI人工智能模块和HW-Link多功能数据链，支持便携PAD操控终端、双屏地面站等多种专业操控模式，能够实现目标自动识别、锁定、追踪、瞄准等功能，支持定制化开发特种专业应用功能，满足特种专业应用场景需求。',
    'text4': '产品参数',
    'text5': '查看',
    'text6': '关闭',

    'text7': 'HW-Gimbal 特种机械增稳光电吊舱',
    'text8': '孔先生：13240113344（微信同号）',
    'text9': '邮箱：public@aeronitor.com',


    'tb_txt1': 'HW-Gimbal 特种多框架三轴机械增稳吊舱',
    'tb_txt2': '产品型号',
    'tb_txt3': 'S30F-30X35IDL30',
    'tb_txt4': 'S20T-30X275CD',
    'tb_txt5': 'S30T-30X75LA0',
    'tb_txt6': '尺寸|重量',
    'tb_txt7': '直径200mm,高290mm,重2.4kg',
    'tb_txt8': '直径200mm,高290mm,重4.0kg',
    'tb_txt9': '直径200mm,高292mm,重≤6.0kg',

    'tb_txt10': '电压|功耗',
    'tb_txt11': '18~28V，常规≤40W，峰值≤150W',
    'tb_txt12': '18~28V，常规≤40W，峰值≤150W',
    'tb_txt13': '18~28V，常规≤40W，峰值≤150W',
    'tb_txt14': '增稳类型',
    'tb_txt15': '多框架三轴机械增稳',
    'tb_txt16': '多框架三轴机械增稳',
    'tb_txt17': '多框架三轴机械增稳',
    'tb_txt18': '俯仰 | 航向 | 横滚',
    'tb_txt19': '+35°~-125° | 360°xn | +60°~-60°',
    'tb_txt20': '+45°~-135° | 360°xn | +50°~-50°',
    'tb_txt21': '+45°~-135° | 360°xn | +60-°~-60°',
    'tb_txt22': '稳定精度',
    'tb_txt23': '≤0.1mrad',
    'tb_txt24': '≤0.1mrad',
    'tb_txt25': '≤0.1mrad',

    'tb_txt26': '可见光',
    'tb_txt27': '镜头',
    'tb_txt28': '30x光变；焦距4.3~129mm；F1.6~4.7',
    'tb_txt29': '30x光变；焦距4.3~129mm；F1.6~4.7',
    'tb_txt30': '30x光变；焦距4.3~129mm；F1.6~4.7',
    'tb_txt31': '影像',
    'tb_txt32': 'FHD，1080P@30fps',
    'tb_txt33': 'FHD，1080P@30fps',
    'tb_txt34': 'FHD，1080P@30fps',
    'tb_txt35': 'FOV',
    'tb_txt36': '63.7°(广角端)~2.3(长焦端)',
    'tb_txt37': '63.7°(广角端)~2.3(长焦端)',
    'tb_txt38': '63.7°(广角端)~2.3(长焦端)',
    'tb_txt39': '热红外',
    'tb_txt40': '分辨率',
    'tb_txt41': '640x512，12μm像元',
    'tb_txt42': '640x512，15μm像元',
    'tb_txt43': '640x512，17μm像元',

    'tb_txt44': '类型',
    'tb_txt45': '非制冷氧化钒焦平面阵列8~14μm',
    'tb_txt46': '斯特林制冷器，波段3.7~4.8μm',
    'tb_txt47': '非制冷氧化钒焦平面阵列8~14μm',
    'tb_txt48': '焦距',
    'tb_txt49': '35mm，F1.0',
    'tb_txt50': '20mm~275mm，F5.5',
    'tb_txt51': '75mm',
    'tb_txt52': '激光测距',
    'tb_txt53': '波长',
    'tb_txt54': '1530~1540nm',
    'tb_txt55': '一 一',
    'tb_txt56': '1.535μm+0.015μm',
    'tb_txt57': '测量范围',
    'tb_txt58': '50~3000m',
    'tb_txt59': '一 一',
    'tb_txt60': '50~10000m (可定制)',

    'tb_txt61': '测量精度',
    'tb_txt62': '2m',
    'tb_txt63': '一 一',
    'tb_txt64': '±2m',
    'tb_txt65': 'AI模块',
    'tb_txt66': '目标检测',
    'tb_txt67': '外置',
    'tb_txt68': '外置',
    'tb_txt69': '48x48~384x384(pix x pix)；≤20ms',
    'tb_txt70': '功能',
    'tb_txt71': '画中画、OSD(可叠加字符、瞄准线、角度等信息)、支持编码视频输出等、64G内存 (18h内录) 、AI目标自动识别、锁定、跟踪、AR叠加等',
    'tb_txt72': '接口',
    'tb_txt73': '吊舱控制',
    'tb_txt74': 'CAN、S-BUS、RS232、TTL、异步422',
    'tb_txt75': '视频输出',
    'tb_txt76': '网口、同步422、HDMI-OUT',
    'tb_txt77': '环境适应',
    'tb_txt78': '工作温度: -20°C~55°C； 存储温度: -40°C~60°C',

    'productParameter': [
      {
        'title': "HW-Gimbal S20-95-1 两轴双光自动观瞄吊舱",
        'desc': "30x光学变焦可见光，1km激光测距仪，下挂了95-1，具备俯仰及航向增稳能力,增稳精度达0.5mrad，三载荷光学同轴，可实现自动瞄准、追踪和精准打击。",
        'params': [
          {
            'label': "尺寸|重量",
            'value': "高460mm，长753mm，宽261mm， 重10.5kg"
          }, {
            'label': "电压|功耗",
            'value': "18~28V，常规≤25W，峰值≤150W"
          }, {
            'label': "增稳性能",
            'value': "两轴机械增稳，增稳精度≤0.1mrad"
          }, {
            'label': "俯仰|航向",
            'value': "+10°~-35° | +45°~-45°"
          }, {
            'label': "可见光",
            'value': "30x光变，1080P@30fps，FOV:63.7°(广角端)~2.3°(长焦端)"
          }, {
            'label': "激光测距",
            'value': "波长900~908nm，测距3.5~800m，精度1m"
          }, {
            'label': "跟踪模块",
            'value': "跟踪目标48x48~384x384(pix x pix)，响应时间<50ms"
          }, {
            'label': "打击精度",
            'value': "25m动态目标优于±5cm，50m动态目标优于±10cm"
          }, {
            'label': "环境适应性",
            'value': "工作温度: -20°C~55°C；存储温度: -40°C~60°C"
          }
        ]
      },
      {
        'title': "HW-Gimbal S30T-30X35LD20 三轴三光照射吊舱",
        'desc': "集成30x光学变焦可见光、红外和激光照射模块，可拓展AI智能模块实现对动目标的自动识别、锁定和追踪，可胜任全时段侦查和激光照射任务，引导精准打击。",
        'params': [
          {
            'label': "尺寸|重量",
            'value': "直径≤172mm，高≤265mm， 重≤2.5kg"
          }, {
            'label': "电压|功耗",
            'value': "18~28V，常规≤25W，峰值≤250W (照射器工作)"
          }, {
            'label': "增稳性能",
            'value': "多框架三轴机械增稳，增稳精度≤0.1mrad"
          }, {
            'label': "俯仰 | 航向 | 横滚",
            'value': "+45°~-135° | 360°xn | +40°~-40°"
          }, {
            'label': "可见光",
            'value': "30x光变，1080P@30fps，FOV:63.7(广角端)~2.3°(长焦端)"
          }, {
            'label': "红外",
            'value': "640x512，非制冷氧化钒焦平面阵列8~14μm，35mm定焦"
          }, {
            'label': "激光照射",
            'value': "波长1.064μm，脉冲能量≥25mJ，照射距离≥2km，测距精度±1m"
          }, {
            'label': "跟踪模块",
            'value': "跟踪目标48x48~384x384(pix x pix)，响应时间<50ms"
          }, {
            'label': "环境适应性",
            'value': "工作温度: -20°C~55°C；存储温度: -40°C~60°C"
          }
        ]
      },
      {
        'title': "HW-Gimbal S10T-SP300 专业级多框架三轴增稳测绘吊舱",
        'desc': "高精度三轴机械增稳吊舱平台+飞思专业航测相机，实现了在角度保持下的高分辨率影像采集，可支持图片数据实时回传，适用于远距离高地表分辨率航测任务。",
        'params': [
          {
            'label': "尺寸|重量",
            'value': "直径300mm，高435mm， 重9.1kg"
          }, {
            'label': "电压|功耗",
            'value': "18~28V，常规≤25W，峰值≤200W"
          }, {
            'label': "增稳性能",
            'value': "多框架三轴机械增稳，增稳精度0.2mrad"
          }, {
            'label': "俯仰 | 航向 | 横滚",
            'value': "+25°~-135° | 360°xn | +30°~-30°"
          }, {
            'label': "测绘相机",
            'value': "飞思专业航测相机"
          }, {
            'label': "传感器",
            'value': "背照式CMOS，像素11664x8750，像元间距3.76μm"
          }, {
            'label': "镜头",
            'value': "300mm定焦"
          }, {
            'label': "地表分辨率",
            'value': "1.253cm@1000m，2.506cm@2000m，3.759cm@3000m"
          }, {
            'label': "环境适应性",
            'value': "工作温度: -20°C~55°C；存储温度: -40°C~60°C"
          }
        ]
      }
    ]

  },
  'avionics_link': {
    'text1': 'HW-Link图数音一体数据链',
    'text2': '专注为各型高阶无人机提供完整解决方案',
    'text3': ' HW-Link系列图数音一体多功能数据链融合了高清图传链路、数控链路、差分校正链路，多路合一，可为各种无人机提供稳定、低延时、远距离的高清影像和数据通讯保障，HW-Link系列产品分为: 30km、50km、100km、200km等多个版本。',
    'text4': 'HW-Link系列数据链产品支持“机-机”中继模式，最远可实现超过300km的高清影像和数据通讯；能够保障1V4、1V1集群无人机通信；可搭配地面转台中继系统实现更远距离的稳定通信，广泛适用于长距离输电线路巡检、油气管道巡护、海事巡航、边防巡逻、森林消防、军事侦查等场景。',
    'text5': 'HW-Link图数音一体数据链特色优点',
    'text6': '产品参数',
    'text7': '查看',
    'text8': '关闭',
    'applicationTitle': "适用多型无人载具",
    'tel': "孔先生：13240113344（微信同号）",
    'email': "邮箱：public@aeronitor.com",
    'applyData': [
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "图数音一体、多路合一",
        'desc': "融合了高清图传链路(支持高清视频、图片、声音等) 、数控链路、差分校正链路，多路合一，部署简单，功能全面。",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "图数音一体、多路合一"
      },
      {
        'type': '0',
        'title': "支持“机-机”中继，广泛适用",
        'desc': "支持“机-机”中继模式，即使在山区通讯遮挡、海上微波反射和吸收等环境下也能保障稳定通联。",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "支持“机-机”中继，广泛适用"
      },
      {
        'type': '0',
        'title': "支持基站漫游、全域覆盖",
        'desc': "支持基站漫游功能，通过分布式部署多个漫游基站，可实现城市级无盲区的全域通讯覆盖。",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "支持基站漫游、全域覆盖"
      },
      {
        'type': '0',
        'title': "拓展定向转台，更远通讯半径",
        'desc': "可拓展地面转台中继系统，自动追踪无人机实时位置，实现更远的通讯半径。",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "拓展定向转台，更远通讯半径"
      },
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "支持吊舱操控、简单方便",
        'desc': "支持便携PAD吊舱控制和PC上位机吊舱远程控制，提供多种载荷控制接口，载荷操控更简单方便。",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "支持吊舱操控、简单方便"
      },
      {
        'type': '0',
        'title': "支持集群通讯、高效协同",
        'desc': "HW-Link集群数据链支持1V4、1V16等多种集群无人机通信模式，全面保障无人机集群高效协同。",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "支持集群通讯、高效协同"
      }
    ],
    'application': [
      {
        'label': "HW-Link1V4集群数据链",
        'img': "/static/images/avionics/common/1.jpg"
      },
      {
        'label': "HW-Link 30km、50km数据链",
        'img': "/static/images/avionics/common/1.jpg"
      },
      {
        'label': "HW-Link 100km数据链",
        'img': "/static/images/avionics/common/2.png"
      },
      {
        'label': "HW-Link 200km数据链",
        'img': "/static/images/avionics/common/3.png"
      },
      {
        'label': "小型地面转台中继数据链",
        'img': "/static/images/avionics/common/4.png"
      },
      {
        'label': "机载跟踪数据链",
        'img': "/static/images/avionics/common/5.png"
      },
      {
        'label': "大型地面转台中继数据链",
        'img': "/static/images/avionics/common/1.jpg"
      }
    ],
    'productParameter': [

      {
        'title': ['HW-Link100'],
        'columnSpan': 4,
        'data': [
          {
            'label': "工作频段",
            'value': "1430~1444MHz",
            'label2': "发射功率",
            'value2': "ANT1: 41±1dBm; ANT2: 23±1dBm"
          },
          {
            'label': "接收灵敏度",
            'value': "ANT1: ≤-89dBm; ANT2: ≤-90dBm",
            'label2': "最远通信距离",
            'value2': "7Mbps@100km (全向天线，1080P@30fps)"
          },
          {
            'label': "分集方式",
            'value': "非对称2x2MINO，发射分集+接收分集",
            'label2': "支持媒体类型",
            'value2': "1080P高清视频、图片、声音等"
          },
          {
            'label': "支持数传功能",
            'value': "115200bps，RS232",
            'label2': "支持RTK校准",
            'value2': "115200bps，RS232"
          }
        ]
      },
      {
        'title': ['地面端', '机载端'],
        'columnSpan': 2,
        'data': [
          {
            'label': "尺寸",
            'value': "130mmx100mmx66mm",
            'label2': "尺寸",
            'value2': "130mmx63mmx66mm"
          },
          {
            'label': "重量",
            'value': "606g (不含天线)",
            'label2': "重量",
            'value2': "554g (不含天线)"
          },
          {
            'label': "天线长度",
            'value': "120cm",
            'label2': "天线长度",
            'value2': "138mm"
          },
          {
            'label': "天线重量",
            'value': "400gx2",
            'label2': "天线重量",
            'value2': "14.2gx2"
          },
          {
            'label': "天线增益",
            'value': "6dBi",
            'label2': "天线增益",
            'value2': "2dBi"
          },
          {
            'label': "工作电压",
            'value': "24V±10% (6S锂电池)",
            'label2': "工作电压",
            'value2': "24V±10% (6S锂电池)"
          },
          {
            'label': "工作功耗",
            'value': "&le;20W",
            'label2': "工作功耗",
            'value2': "&le;50W"
          },
          {
            'label': "工作环境温度",
            'value': "-10°C~60°C",
            'label2': "工作环境温度",
            'value2': "-10°C~60°C"
          },
          {
            'label': "支持视频输出",
            'value': "HDMI 1080P@60fps",
            'label2': "支持视频输出",
            'value2': "SDI 1080P@30fps"
          },
          {
            'label': "支持以太网",
            'value': "100Mbps",
            'label2': "支持以太网",
            'value2': "100Mbps (定制)"
          },
          {
            'label': "数据链路接口",
            'value': "RS232x3",
            'label2': "数据链路接口",
            'value2': "RS232x3"
          }
        ]
      }
    ]
  },
  'avionics_pilot': {
    'text1': 'HW-Pilot 无人机飞控系统',
    'text2': '专注为各型高阶无人机提供完整解决方案',
    'text3': '采用三余度安全冗余硬件架构，集成RTK高精度定位模块，支持各型复合翼、固定翼、中大型多旋翼、变距多旋翼、单旋翼直升机、共轴直升机、纵列式直升机、巡飞弹等机型',
    'text4': '可配套提供包含数图一体多功能数据链、多框架三轴机械增稳光电吊舱、机载AI等高阶无人机系统完整解决方案和整机装机服务，支持半实物仿真训练系统、全功能后台直播管理系统等拓展应用仅需匹配个性化',
    'text5': 'HW-Pilot 无人机飞控系统特色优点',
    'text6': '产品参数',
    'text7': '查看',
    'text8': '关闭',
    'applicationTitle': "适用多型无人载具",
    'tel': "孔先生：13240113344（微信同号）",
    'email': "邮箱：public@aeronitor.com",
    'application': [
      {
        'label': "小、中、大型复合翼无人机",
        'img': "/static/images/avionics/common/1.jpg"
      },
      {
        'label': "中、大型多旋翼无人机",
        'img': "/static/images/avionics/common/2.png"
      },
      {
        'label': "变距多旋翼无人机",
        'img': "/static/images/avionics/common/3.png"
      },
      {
        'label': "单旋翼、共轴无人直升机",
        'img': "/static/images/avionics/common/4.png"
      },
      {
        'label': "纵列双旋翼无人直升机",
        'img': "/static/images/avionics/common/5.png"
      },
      {
        'label': "巡飞弹",
        'img': "/static/images/avionics/common/1.jpg"
      }
    ],
    'applyData': [
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "参数辨识建模+现代鲁棒控制",
        'desc': "采用机体参数辨识建模+现代鲁棒控制，确保系统的健壮性和优秀的控制性能",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "参数辨识建模+现代鲁棒控制"
      },
      {
        'type': '0',
        'title': "GNSS卫星拒止条件下可正常工作",
        'desc': "独特的不依赖卫星导航的算法，在卫星拒止条件下可通过光电吊舱持续锁定并跟踪目标",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "GNSS卫星拒止条件下可正常工作"
      },
      {
        'type': '0',
        'title': "高可靠性、支持大型无人机",
        'desc': "三余度硬件安全冗余设计，拓展卡尔曼滤波算法，历经15万余架次飞行检验，支持大型无人机平台和多类机型",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "高可靠性、支持大型无人机"
      },
      {
        'type': '0',
        'title': "可扩展激光雷达建图、避障、里程计",
        'desc': "雷达惯性里程计LIO+视觉惯性里程计VIO，在高层楼间灭火悬停等场景下可保障稳定安全",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "可扩展激光雷达建图、避障、里程计"
      },
      {
        'type': '0', // 1 独占一行 0 两个共占一行
        'title': "舰载、车载等动平台起降",
        'desc': "可拓展动平台功能模块，支持舰载、车载等移动平台行进中起飞和降落，广泛适用于海上、机动起降场景",
        'img': "/static/images/avionics/common/application1.jpg",
        'alt': "舰载、车载等动平台起降"
      },
      {
        'type': '0',
        'title': "支持各种专业航空发动机",
        'desc': "可兼容控制宗申C145H、航瑞DB416、ROTAX915等专业航空发动机",
        'img': "/static/images/avionics/common/application2.jpg",
        'alt': "支持各种专业航空发动机"
      },
      {
        'type': '0',
        'title': "半实物仿真训练系统、后台直播管理系统",
        'desc': "可拓展半实物仿真训练系统，降低训练成本和风险，支持后台直播管理，随时随地掌握现场实况",
        'img': "/static/images/avionics/common/application3.jpg",
        'alt': "半实物仿真训练系统、后台直播管理系统"
      },
      {
        'type': '0',
        'title': "完整解决方案、整机装机服务",
        'desc': "提供包含数图一体多功能数据链、多框架三轴机械增稳光电吊舱、机载AI等高阶无人机系统完整解决方案和整机装机服务",
        'img': "/static/images/avionics/common/application4.jpg",
        'alt': "完整解决方案、整机装机服务"
      }],
    'productParameter': [

      {
        'label': "陀螺仪量程",
        'value': "±2000dps",
        'label2': "加速度量程",
        'value2': "±16g"
      },
      {
        'label': "高度分辨率",
        'value': "0.1m",
        'label2': "静压传感器",
        'value2': "120kPa"
      },
      {
        'label': "缸温采集",
        'value': "支持",
        'label2': "动压传感器",
        'value2': "137.9kPa，支持1707km/h"
      },
      {
        'label': "转速采集",
        'value': "支持",
        'label2': "CAN总线",
        'value2': "3路CAN通信，支持智能电池"
      },
      {
        'label': "油量采集",
        'value': "支持",
        'label2': "S-BUS总线",
        'value2': "1路SBUS，可接SBUS接收机"
      },
      {
        'label': "航拍POS数据",
        'value': "10K",
        'label2': "PWM通道",
        'value2': "12路输出"
      },
      {
        'label': "数据存储",
        'value': "8G",
        'label2': "串口",
        'value2': "6路"
      },
      {
        'label': "GPS定位精度",
        'value': "2.5m",
        'label2': "GPS更新频率",
        'value2': "10Hz"
      },
      {
        'label': "RTK主要功能",
        'value': "RTK、PPK、双天线测向",
        'label2': "RTK定位精度",
        'value2': "水平1cm+1ppm、垂直2cm+1ppm"
      },
      {
        'label': "RTK定向精度",
        'value': "0.2/D°(D为天空端天线间距，单位m)",
        'label2': "RTK工作频点",
        'value2': "GPS：L1、L2；GLONASS：G1、G2；BD：B1、B2(可选配B3)"
      },
      {
        'label': "RTK测速精度(RMS)",
        'value': "0.02m/s",
        'label2': "PPK",
        'value2': "频率：2Hz，5Hz，10Hz；存储空间：8GB；数据读取接口：USB2.0"
      },
      {
        'label': "供电电压",
        'value': "6～26V",
        'label2': "功耗",
        'value2': "<6W"
      },
      {
        'label': "工作温度",
        'value': "-20℃～60℃",
        'label2': "存储温度",
        'value2': "-40℃～80℃"
      },
      {
        'label': "飞控模块重量",
        'value': "217g",
        'label2': "飞控模块尺寸",
        'value2': "112mmx100mmx35mm"
      },
      {
        'label': "GPS模块重量",
        'value': "41g",
        'label2': "GPS模块尺寸",
        'value2': "55mm(直径)x13mm"
      },
      {
        'label': "软件语音",
        'value': "中文",
        'label2': "操作系统",
        'value2': "Microsoft Windows 7/8/10，32/64 bits"
      }
    ]
  },
  'avionics_pod': {
    'text1': '吊舱',
    'text2': '三轴陀螺稳定平台',
    'text3': '1080P高清图传 30倍光学变焦 抗风阻球形设计',
    'text4': '高精度目标识别、跟踪',
    'text5': '搭载高清可见光摄像机和精准红外摄像仪集成CNN智能视觉跟踪算法，可克服临时遮挡等障眼假象，稳定跟踪目标',
    'text6': '高清成像，视若亲临',
    'text7': '搭载的可见光摄像机具备30倍光学变焦能力，高清成像，突破视觉束缚。',
    'text8': '高清成像，视若亲临',
    'text9': '搭载的可见光摄像机具备30倍光学变焦能力，高清成像，突破视觉束缚。',
    'text10': '解决方案定制专家',
    'text11': '查看',
    'text12': '关闭',
    'text13': '销售热线：010-58650999',
    'text14': '邮箱：public@aeronitor.com',
  },
  'avionics_polaris': {
    'text1': 'Polaris三余度自动驾驶仪',
    'text2': '全新Polaris三余度自动驾驶仪采用三冗余安全设计',
    'text3': '优选高性能传感器，稳定可靠',
    'text4': '优化算法，保障飞行安全',
    'text5': '采用三冗余安全设计，三套算法独立运算，数据之间互为备份，故障时可顺利切换系统，确保飞行安全。创新的融合了L1非线性导航算法和B747级总能量控制算法，增强了无人机应对湍流、风切变的能力，让飞行任务更具保障。',
    'text6': '选材考究，匠心设计',
    'text7': '优选工业级IMU，具有高精度、高稳定性、高可靠性，无惧苛刻环境。产品采用模块化设计，航空级插头，解决机舱内部走线杂乱问题。',
    'text8': '全方位保护，安全可靠',
    'text9': '自检系统可在起飞前对无人机进行全面快速的检验。发现异常，系统拒绝解锁，防患于未然；同时具有完备的应急保护机制，支持预置迫降航点，遇紧急情况，可原地盘旋或自主迫降。',
    'text10': '强大的数据支持',
    'text11': '黑匣子数据记录系统，集成4GB数据存储容量SD卡，可提供长达50小时以上的飞行数据实时记录。',
    'text12': '智能视觉定位模块(*选模块)',
    'text13': '集成双目深度图和视觉惯性里程计(Visual‒InertialOdometry)系统，可在山谷、楼宇间等无GPS信号的情况下实现自主起飞、降落和避障，降低了对作业环境的要求，适用范围更加广泛。',
    'text14': '地面站软件',
    'text15': '配套的地面站软件，可实现Polaris自动驾驶仪在线调参、飞行任务规划等强大功能，具备友好的人性化界面，操作便捷、易用性高。',
    'text16': '功能特性',
    'text17': '解决方案定制专家',
    'text18': '查看',
    'text19': '关闭',
    'text20': '销售热线：010-58650999',
    'text21': '邮箱：public@aeronitor.com',
    'characteristicsData': [
      {
        'title': "适配多种机型",
        'desc': "V尾、飞翼、串列式等"
      },
      {
        'title': "支持多种起降模式",
        'desc': "垂直起降、滑跑起降、弹射、车载起飞、伞降"
      },
      {
        'title': "支持多种飞行控制模式",
        'desc': "手动、半自动、全自主飞行"
      },
      {
        'title': "支持多种连接方式",
        'desc': "可识别物理连接，即插即用、扩展性强"
      },
      {
        'title': "支持转速",
        'desc': "缸温、油量、多路电压采集，并预留多路备用AD"
      },
      {
        'title': "支持RTK",
        'desc': "实时动态差分技术定位精度可达厘米级"
      },
      {
        'title': "支持PPK",
        'desc': "事后差分全球定位系统"
      },
      {
        'title': "可搭载光电吊舱，等距、定点曝光相机",
        'desc': "支持拍照控制和自动POS数据保存"
      }
    ],
  },
  //-------------
  'index_index': {},
  //-------------
  'industry_hw600': {
    'text1': '200kg净载荷',
    'text2': '续航时间久',
    'text3': '纵列式布局结构，载重能力强。',
    'text4': '满足1—8小时续航时间，飞行速度可达150km/h',
    'text5': '200kg净载荷 1h续航',
    'text6': '150kg载荷 3.5h续航',
    'text7': '抗卫星导航干扰',
    'text8': '支持无卫星导航模式下的视觉惯导融合导航飞行模式，卫星导航信号被干扰或者受到诱骗情况时，无人机仍能正常执行任务或者依靠视觉融合导航精准降落返航，全程稳定可靠，安全作业。',
    'text9': '装载空间大，重心范围大，适合吊挂',
    'text10': '整机旋翼采用一前一后布局，重心范围大，',
    'text11': '装载空间大，支持吊挂各种大型设备。',
    'text12': '激光雷达全向避障',
    'text13': '具备自主感知避障识别能力，不受环境光线、烟尘等影响，支持自动绕障和仿地飞行功能，保障无人机全天候及复杂环境下的飞行安全与稳定。',
    'applicationTitle': "广泛的应用场景",
    'application': [
      {
        'label': "应急保障物资投送",
        'img': "/static/images/industry/hw600/application1.png"
      },
      {
        'label': "电力检修物资运输",
        'img': "/static/images/industry/hw600/application2.png"
      },
      {
        'label': "应急通信信号保障",
        'img': "/static/images/industry/hw600/application3.png"
      },
      {
        'label': "异构集群精准灭火",
        'img': "/static/images/industry/hw600/application4.png"
      }
    ]
  },
  //--------------
  'industry_hw16v': {
    'text1': '电动垂直起降复合翼无人机',
    'text2': '行业产品 > 工业整机 > HW-16V',
    'text3': 'HW-16V性能优势',
    'text4': '采用三余度安全飞控，双天线差分定向，机载AI算力，具有：长航时、全场景、模块化、垂直起降等众多优点，非常适用于远程实时视频巡检场景',
    'text5': '使用多种任务场景',
    'text6': '警用、测绘、石油、电力、应急、环保、海事、林草',
    'param': {
      'text0': '产品参数',
      'text1': '动力',
      'text1_1': '锂电池',
      'text2': '续航时间',
      'text3': '巡航速度',
      'text4': '有效载荷',
      'text5': '最大起飞重量',
      'text6': '抗风能力',
      'text7': '机身尺寸',
      'text8': '最大飞行高度',
      'text9': '运输箱尺寸(m)',
    },
    'advantages': [
      {
        'title': "纯电动 长航时",
        'childen': [
          '纯电驱动，一次起飞更长有效作业时间',
        ]
      },
      {
        'title': "VTOL",
        'childen': [
          '垂直起降，模块化载荷设计，多种任务载荷可选择，适用多种任务场景',
        ]
      },
      {
        'title': "机载AI、AR",
        'childen': [
          '目标自动识别、锁定、追踪AR数据实时叠加呈现',
        ]
      },
      {
        'title': "支持“机-机中继",
        'childen': [
          '创新的双机组合中继技术，解决了山区等复杂地形下的远距离实时通讯难题',
        ]
      },
      {
        'title': "抗反制、抗干扰",
        'childen': [
          '专有传感器+闭环姿态算法,卫星拒止环境、GPS干扰环境及诱骗环境下保证稳定飞行',
        ]
      },
      {
        'title': "动平台起降",
        'childen': [
          '内置抗干扰传感器，可在高速移动或复杂海况等非平稳状态下的起降',
        ]
      },
    ],
  },
  'industry_hw25v': {
    'text1': '电动垂直起降复合翼无人机',
    'text2': '行业产品 > 工业整机 > HW-16V',
    'text3': 'HW-16V性能优势',
    'text4': '采用三余度安全飞控，双天线差分定向，机载AI算力，具有：长航时、全场景、模块化、垂直起降等众多优点，非常适用于远程实时视频巡检场景',
    'text5': '使用多种任务场景',
    'text6': '警用、测绘、石油、电力、应急、环保、海事、林草',
  },
  'industry_hw60v': {
    'text1': '垂直起降复合翼无人机',
    'text2': '行业产品 > 工业整机 > HW-60V',
    'text3': 'HW-60V性能优势',
    'text4': '电动/油动  长航时 全场景适用',
    'text5': '使用多种任务场景',
    'text6': '警用、测绘、石油、电力、应急、环保、海事、林草',
    'param': {
      'text0': '产品参数',
      'text1': '动力',
      'text1_1': '汽油/重油',
      'text2': '续航时间',
      'text3': '巡航速度',
      'text4': '有效载荷',
      'text5': '最大起飞重量',
      'text6': '抗风能力',
      'text7': '机身尺寸',
      'text8': '最大飞行高度',
      'text9': '运输箱尺寸(m)',
    },
    'advantages': [
      {
        'title': "更强的性能",
        'childen': [
          '4—8小时',
          '50km/100km/300km 有效作业半径可定制',
          '15kg模块化载荷'
        ]
      },
      {
        'title': "全天候飞行能力",
        'childen': [
          '抗风等级：巡航抗风7级',
          '抗雨能力：小雨长时间飞行，中雨单次≥3h大雨单次≥1h',
        ]
      },
      {
        'title': "更安全",
        'childen': [
          '双天线差分定向技术',
          '高集成航电系统',
          '三余度安全飞控'
        ]
      },
      {
        'title': "技术创新",
        'childen': [
          '抗诱骗/干扰',
          '专有传感器+闭环姿态算法',
          '卫星拒止环境、GPS干扰环境及诱骗环境下保证稳定飞行',
        ]
      },
      {
        'title': "数据链",
        'childen': [
          '标配50km（电动）/100km(油动)数据链，可扩展至300km，支持“机-机中继“技术',
        ]
      },
      {
        'title': "AI + AR",
        'childen': [
          'AR数据叠加，防止迷航',
          '人、车、动物等密度实时统计',
          '机载AI，人、车等动目标识别、锁定、追踪',
        ]
      },
      {
        'title': "动平台起降+异地起降",
        'childen': [
          '内置抗干扰传感器，可在高速移动或复杂海况等非平稳状态下的起降。',
          '支持100km范围内的异地起降',
        ]
      },
      {
        'title': "喊话器、激光雷达、多样化任务载荷",
        'childen': [
          '载重能力可达15kg，可搭载喊话器、光电吊舱、激光雷达、测绘相机等各种丰富载荷，全场景⼴泛适⽤',
        ]
      },
    ],
  },
  'industry_hw120v': {
    'text1': '垂直起降复合翼无人机',
    'text2': '行业产品 > 工业整机 > HW-120V',
    'text3': 'HW-120V性能优势',
    'text4': '电动/油动  长航时 全场景适用',
    'text5': '使用多种任务场景',
    'text6': '警用、测绘、石油、电力、应急、环保、海事、林草',
    'param': {
      'text0': '产品参数',
      'text1': '动力',
      'text1_1': '汽油',
      'text2': '续航时间',
      'text3': '巡航速度',
      'text4': '有效载荷',
      'text5': '最大起飞重量',
      'text6': '抗风能力',
      'text7': '机身尺寸',
      'text8': '最大飞行高度',
      'text9': '运输箱尺寸(m)',
    },
    'advantages': [
      {
        'title': "更强的性能",
        'childen': [
          '10小时',
          '100km/300km+ 有效作业半径可定制',
          '40kg模块化载荷'
        ]
      },
      {
        'title': "全天候飞行能力",
        'childen': [
          '抗风等级：巡航抗风7级',
          '抗雨能力：小雨长时间飞行，中雨单次≥3h大雨单次≥1h',
        ]
      },
      {
        'title': "更安全",
        'childen': [
          '双天线差分定向技术',
          '高集成航电系统',
          '三余度安全飞控'
        ]
      },
      {
        'title': "技术创新",
        'childen': [
          '抗诱骗/干扰',
          '专有传感器+闭环姿态算法',
          '卫星拒止环境、GPS干扰环境及诱骗环境下保证稳定飞行',
        ]
      },
      {
        'title': "数据链",
        'childen': [
          '标配100km数据链，可扩展至300km+，支持“机-机中继“技术',
        ]
      },
      {
        'title': "AI + AR",
        'childen': [
          'AR数据叠加，防止迷航',
          '人、车、动物等密度实时统计',
          '机载AI，人、车等动目标识别、锁定、追踪',
        ]
      },
      {
        'title': "动平台起降+异地起降",
        'childen': [
          '内置抗干扰传感器，可在高速移动或复杂海况等非平稳状态下的起降。',
          '支持300km范围内的异地起降',
        ]
      },
      {
        'title': "喊话器、激光雷达、多样化任务载荷",
        'childen': [
          '载重能力可达40kg，可搭载喊话器、光电吊舱、激光雷达、测绘相机、卫通+基站等各种丰富载荷，全场景⼴泛适⽤',
        ]
      },
    ],
  },
  'industry_hw150v': {
    'text1': '垂直起降复合翼无人机',
    'text2': '行业产品 > 工业整机 > HW-150V',
    'text3': 'HW-150V性能优势',
    'text4': '电动/油动  长航时 全场景适用',
    'text5': '使用多种任务场景',
    'text6': '警用、测绘、石油、电力、应急、环保、海事、林草',
    'param': {
      'text0': '产品参数',
      'text1': '动力',
      'text1_1': '汽油',
      'text2': '续航时间',
      'text3': '巡航速度',
      'text4': '有效载荷',
      'text5': '最大起飞重量',
      'text6': '抗风能力',
      'text7': '机身尺寸',
      'text8': '最大飞行高度',
      'text9': '运输箱尺寸(m)',
    },
    'advantages': [
      {
        'title': "更强的性能",
        'childen': [
          '8小时',
          '100km/300km+ 有效作业半径可定制',
          '40kg模块化载荷'
        ]
      },
      {
        'title': "全天候飞行能力",
        'childen': [
          '抗风等级：巡航抗风7级',
          '抗雨能力：小雨长时间飞行，中雨单次≥3h大雨单次≥1h',
        ]
      },
      {
        'title': "更安全",
        'childen': [
          '双天线差分定向技术',
          '高集成航电系统',
          '三余度安全飞控'
        ]
      },
      {
        'title': "技术创新",
        'childen': [
          '抗诱骗/干扰',
          '专有传感器+闭环姿态算法',
          '卫星拒止环境、GPS干扰环境及诱骗环境下保证稳定飞行',
        ]
      },
      {
        'title': "数据链",
        'childen': [
          '标配100km数据链，可扩展至300km+，支持“机-机中继“技术',
        ]
      },
      {
        'title': "AI + AR",
        'childen': [
          'AR数据叠加，防止迷航',
          '人、车、动物等密度实时统计',
          '机载AI，人、车等动目标识别、锁定、追踪',
        ]
      },
      {
        'title': "动平台起降+异地起降",
        'childen': [
          '内置抗干扰传感器，可在高速移动或复杂海况等非平稳状态下的起降。',
          '支持300km范围内的异地起降',
        ]
      },
      {
        'title': "喊话器、激光雷达、多样化任务载荷",
        'childen': [
          '载重能力可达40kg，可搭载喊话器、光电吊舱、激光雷达、测绘相机、卫通+基站等各种丰富载荷，全场景⼴泛适⽤',
        ]
      },
    ],
  },
  'industry_zt25v': {
    'text1': '产品介绍',
    'text2': '技术参数',
    'text3': '电动长航时垂直起降固定翼无人机',
    'text4': '纯电动',
    'text5': '长航时',
    'text6': '全场景适用',
    'text7': '更强的性能',
    'text8': '带载作业续航',
    'text9': '有效作业半径可定制',
    'text10': '模块化载荷',
    'text11': '全天候飞行能力',
    'text12': '抗风能力：',
    'text13': '巡航抗风7级',
    'text14': '抗雨能力：',
    'text15': '小雨长时间飞行，中雨单次≥3小时，大雨单次≥1小时',
    'text16': '更安全',
    'text17': '双天线差分定向技术',
    'text18': '高度集成的“四合一”航电系统',
    'text19': '更安全的三余度安全飞控',
    'text20': '技术创新',
    'text21': '云巡系统',
    'text22': '“云巡”系统功能涵盖设备、⼈员、航线、任务、数据、解禁等⽆⼈机运营管理全部业务流程， 支持高清直播、视频分发、空地联动、双向互动等前沿功能。',
    'text23': '喊话器、激光雷达、多样化任务载荷',
    'text24': '载重能力可达10kg，可搭载喊话器、光电吊舱、激光雷达、测绘相机等各种丰富载荷。',
    'text25': '还可拓展⽀持多光谱、⽓体检测等更多任务载荷，全场景⼴泛适⽤。',
    'text26': '飞行器',
    listData: [
      {
        title: "抗诱骗/干扰",
        desc: "通过专有的传感器和姿态闭环算法，在被干扰和诱骗情况下不依赖卫星定位仍可通过航向及吊舱进行导航，继续执行巡查任务，保障任务飞行和安全返航。",
        img: "/static/images/industry/zt25v/section5_plane1.png",
        alt: "抗诱骗/干扰",
        video: []
      },
      {
        title: "DSM-CAS 智能防撞系统",
        desc: "无人机搭配了基于⻜机动态特性和DSM（数字地表模型）的三维避障寻路算法，在机上完整集成了全国DSM数据，在特殊需求时，还可升级加载高达0.5米精度的DSM。飞控系统自动结合风速、转弯半径、爬升率、机动能力等⻜机动态特性，实时动态规划各种约束条件下的任务航线，并可以⾃动实现对“不安全”航线的智能安全调整。",
        img: "/static/images/industry/zt25v/section5_plane2.png",
        alt: "DSM-CAS 智能防撞系统",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/fangzhuang_pagao.mp4", "https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/fangzhuang_raoxing.mp4"]
      },
      {
        title: "AR数据叠加",
        desc: "无人机通过AR技术，可加载目标kml，经过DSM数据校准后，实时叠加准确的路⽹、线塔、线路、建筑物甚至地面警力分布等特定数据⾄视频画⾯，解决了无人机第⼀视⻆巡检时“迷航”的难题，更加直观易懂地呈现巡检效果。",
        img: "/static/images/industry/zt25v/section5_plane3.png",
        alt: "AR数据叠加",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/AR_shujudiejia.mp4"]
      },
      {
        title: "视频引导降落",
        desc: "无人机搭载了三轴吊舱，在降落时三轴吊舱自动正射朝下，通过AI检测识别，可避开意外出现的车辆人员；在需要动态调整目标点时，还可以简单的拖动地面降落标志，实现视频引导精准降落。",
        img: "/static/images/industry/zt25v/section5_plane4.png",
        alt: "视频引导降落",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/yindaojiangluo.mp4"]
      },
      {
        title: "动平台起降",
        desc: "内置抗干扰传感器，可在高速移动或复杂海况等非平稳状态下的起降",
        img: "/static/images/industry/zt25v/section5_plane5.png",
        alt: "动平台起降",
        video: ["https://tusuav-public.oss-cn-beijing.aliyuncs.com/tusuav-guanwang/product/zt25v/dongpingtaiqijiang.mp4"]
      },
      {
        title: "空中中继",
        desc: "灵隼系列无人机通过空中增加一台中继机的模式进行通讯中转，视频图像从任务机->中继机->地面，不受场地和山区遮挡影响，可真正实现山区环境下50～100km的有效覆盖范围，保障不通视环境下的实时通讯和指挥能力。",
        img: "/static/images/industry/zt25v/section5_plane6.png",
        alt: "空中中继",
        video: []
      }
    ],
    list: [
      {
        title: "动力",
        desc: "锂电池"
      },
      {
        title: "续航时间",
        desc: "3.5h"
      },
      {
        title: "巡航速度",
        desc: "65—120km/h"
      },
      {
        title: "有效载荷",
        desc: "10kg"
      },
      {
        title: "最大起飞重量",
        desc: "36kg"
      },
      {
        title: "抗风能力",
        desc: "10m/s"
      },
      {
        title: "机身尺寸",
        desc: "4.13*1.93*0.76m"
      },
      {
        title: "最大飞行高度",
        desc: "6500m"
      },
      {
        title: "运输箱尺寸",
        desc: "1.56*0.63*0.82"
      }
    ]
  },
  //--------------
  'join_campus': {
    'text1': '概览',
    'text2': '社会招聘',
    'text3': '校园招聘',
    'text4': '校招职位',
    'text5': '简历请发送至： hr@hovwing.com',
    'jobList': [
      {
        'id': "c1",
        'hot': 1,
        'name': "制导与控制算法工程师"
      },
      {
        'id': "c6",
        'hot': 1,
        'name': "无线通信工程师"
      },
      {
        'id': "c7",
        'hot': 0,
        'name': "通信FPGA工程师"
      },

      {
        'id': "c3",
        'hot': 0,
        'name': "视觉算法工程师"
      },
      {
        'id': "c4",
        'hot': 0,
        'name': "AI平台研发工程师"
      },
      // {
      //   id: "c5",
      //   hot: 0,
      //   name: "软件工程师"
      // },
      {
        'id': "c2",
        'hot': 0,
        'name': "嵌入式软件工程师"
      },
      {
        'id': "c8",
        'hot': 0,
        'name': "硬件工程师"
      },
      {
        'id': "c9",
        'hot': 0,
        'name': "机械结构工程师"
      },
      {
        'id': "c12",
        'hot': 0,
        'name': "地面站软件开发工程师"
      },
      // {
      //   id: "c10",
      //   hot: 0,
      //   name: "Web前端开发工程师"
      // },
      // {
      //   id: "c13",
      //   hot: 0,
      //   name: "Java后端开发工程师"
      // },
      {
        'id': "c11",
        'hot': 0,
        'name': "软件测试工程师"
      },
      {
        'id': "c14",
        'hot': 0,
        'name': "销售工程师"
      },
      {
        'id': "c00",
        'hot': 0,
        'name': "更多职位请电话咨询"
      }
    ]
  },
  'join_detail': {
    'text1': '岗位职责',
    'text2': '任职要求',
    'text3': '简历请发送至：',
    'text4': 'hr@hovwing.com',
    'text5': '投递简历',
    'jobContent': [
      {
        'id': "c1",
        'name': "制导与控制算法工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 对飞行系统建模及辨识；\n2. 智能航行路线的规划与设计；\n3. 设计飞行系统的姿态估计与控制算法；\n4. 多传感器的融合以及对传感器的性能分析与标定",
        'demand': ""
      },
      {
        'id': "c2",
        'name': "嵌入式软件工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 对现有产品的维护与升级；\n2. 完成新产品的嵌入式系统开发；\n3. 新技术、新方案与第三方库的调研与探索",
        'demand': ""
      },
      {
        'id': "c3",
        'name': "视觉算法工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1．图像、视频的目标分类，检测，跟踪；场景识别、分割；人脸检测等算法设计；\n2．跟进和应用相关领域前沿技术。",
        'demand': ""
      },
      {
        'id': "c4",
        'name': "AI平台研发工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1．参与嵌入式机器学习平台整体框架设计和实现；\n2．针对机器学习主流框架功能增强及性能优化；\n3．机器学习算法在不同嵌入式体系结构性能优化。",
        'demand': ""
      },
      {
        'id': "c5",
        'name': "软件工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1.负责PC平台无人机地面站软件的开发与维护；\n2.负责无人机GIS系统的开发与维护；\n3.流媒体的软硬件开发与调试；\n4.持续地优化迭代产品的质量、性能、用户体验。",
        'demand': ""
      },
      {
        'id': "c6",
        'name': "无线通信工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 设计无线通信模块和算法；\n2. 参与无人机无线视频传输设备研发；\n3. 无人机无线视频可靠传输协议设计与研发；\n4. 设计实现无人机视频接口和控制接口相关协议如USB，SDI，MIPI，HDMI，UART，CAN，SBUS。",
        'demand': ""
      },
      {
        'id': "c7",
        'name': "通信FPGA工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1．负责FPGA代码编写、模块设计以及功能仿真；\n2．负责FPGA片内调试，并参与硬件电路调试与测试；\n3．理解产品需求，参与整机产品或系统互联的调试与测试",
        'demand': ""
      },
      {
        'id': "c8",
        'name': "硬件工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 参与新产品设计方案的制定和评审；\n2. 产品相关硬件技术文档的编制；\n3. 负责公司相关产品的硬件部分的设计、开发和后期调试；\n4. 负责公司产品硬件架构设计、芯片选型、原理图设计以及PCB设计和调试；\n5. 硬件技术开发相关的外协工作接口及跟踪，积极配合、协调产品的转产工作，跟踪、分析并解决产品在生产和使用过程中暴露出的问题；\n6. 参与和配合公司其他部门的认证、测试等工作。",
        'demand': ""
      },
      {
        'id': "c9",
        'name': "机械结构工程师",
        'area': "北京·海淀",
        'edu': "硕士",
        'station': "研发",
        'duty': "1. 快速拆装结构研究&开发；\n2. 机械结构仿真分析及结构强度校验；\n3. 固定翼或多旋翼无人飞行器机械&结构设计；\n4. 无人飞行器自动起降平台开发（机电一体化方向）；\n5. 无人飞行器挂载设备开发（如云台相机、吊舱、探照灯、喊话器等）",
        'demand': ""
      },
      {
        'id': "c10",
        'name': "Web前端开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责公司信息平台及公司官网的开发与维护;\n2. 根据工作安排，高质、高效地完成代码编写，并且能够进行模块自测，优化、重构等;\n3. 能够与后端开发团队紧密配合，确保代码高效对接;\n4. 能够与各部门同事良好的沟通协作，共同推进工作。",
        'demand': ""
      },
      {
        'id': "c11",
        'name': "软件测试工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 从事无人机及其相关产品的软件功能，兼容性、可靠性、性能等测试工作;\n2. 在需求分析、评审等阶段能够对需求提出合理的优化建议;\n3. 根据需求编写测试用例，制定测试计划，进行bug跟踪及确认，编写测试报告;\n4. 搭建自动化测试平台，设计自动化测试方案，高效完成软件测试工作。",
        'demand': ""
      },
      {
        'id': "c12",
        'name': "地面站软件开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1.负责PC平台无人机地面站软件的开发与维护；\n2.负责无人机GIS系统的开发与维护；\n3.流媒体的软硬件开发与调试；\n4.持续地优化迭代产品的质量、性能、用户体验。",
        'demand': ""
      },
      {
        'id': "c13",
        'name': "Java后端开发工程师",
        'area': "北京·海淀",
        'edu': "本科",
        'station': "研发",
        'duty': "1. 负责管理平台后端服务的数据库设计，业务代码及接口开发工作；\n2. 负责流媒体服务器相关接口及业务的开发及维护工作；\n3. 协作前端、App和测试，完成产品需求的实现迭代及高质量交付；\n4. 制定及实施产品运维方案，安全策略，并编写项目技术文档；\n5. 新技术预研,协助完成方案选型和设计。",
        'demand': ""
      },
      {
        'id': "c14",
        'name': "销售工程师",
        'area': "北京·海淀",
        'edu': "专科",
        'station': "销售",
        'duty': "1.公司现有客户的维护及新客户的开发；\n2.根据公司市场营销战略，积极完成销售指标；\n3.协调公司内部资源，做好客户公关，与客户保持良好沟通。",
        'demand': ""
      },
      {
        id: "s1",
        name: "FPV穿越机飞控开发工程师",
        area: "北京",
        edu: "本科",
        station: "研发",
        duty: "1.负责穿越机样机组装、调试、飞行测试及维护；\n" +
          "2.完成性能测试（如稳定性、可靠性测试）并记录问题，独立输出分析报告提交上级；\n" +
          "3.对测试问题进行分析与解决，优化整机参数配置；\n" +
          "4.负责智能算法扩展或传感器融合。",
        demand: "1.动手能力强，会组装、调试、飞行穿越机；\n" +
          "2.熟练掌握C/C++（嵌入式开发）、Python（算法仿真）；\n" +
          "3.熟悉STM32硬件平台开发调试。\n" +
          "加分项\n" +
          "1.熟悉Betaflight/iNav飞控源码，掌握基本算法原理；\n" +
          "2.掌握传感器扩展和融合算法原理。"
      },
      {
        id: "s2",
        name: "SLAM算法工程师/研究员",
        area: "北京",
        edu: "硕士",
        station: "研发",
        duty: "1.开发基于视觉、激光雷达或多传感器融合的SLAM算法；\n" +
          "    2.优化算法的实时性、鲁棒性和精度，适应复杂场景需求；\n" +
          "    3.解决传感器标定、时间同步等问题；\n" +
          "   4.将SLAM算法集成到实际系统中，并进行性能测试与调优。",
        demand: "1.教育背景：硕士及以上学历，计算机科学、机器人、自动化、电子工程、数学等相关专业。\n" +
          "    2.技术能力：\n" +
          "      1）熟悉常用数学工具（如线性代数、概率论、优化理论等）。\n" +
          "      2） 熟悉SLAM相关算法（如滤波方法、图优化、Bundle Adjustment等）；\n" +
          "      3）熟悉ROS/ROS2等机器人开发框架；\n" +
          "      4）熟悉常用的SLAM框架（如Fast-LIVO2、VINS-Mono、GVINS等）；\n" +
          "      5）熟悉多传感器融合技术，具备IMU、相机、激光雷达、GNSS等传感器的使用经验；\n" +
          "      6）熟练掌握C++/Python编程，熟悉Linux开发环境；\n" +
          "    3.项目经验：\n" +
          "      1）有实际SLAM项目开发经验，熟悉算法从理论到实现的完整流程；\n" +
          "      2） 有机器人、自动驾驶、AR/VR等领域项目经验者优先。\n" +
          "4.加分项：\n" +
          "      1）熟悉深度学习在SLAM中的应用（如语义SLAM、深度估计等）；\n" +
          "      2）熟悉CUDA编程，有GPU加速算法开发经验；\n" +
          "3）有大规模点云处理或三维重建经验。"
      },
      {
        id: "s3",
        name: "高级硬件工程师",
        area: "北京",
        edu: "本科",
        station: "研发",
        duty: "1.\t根据公司产品规划，确定硬件技术路线，完成硬件实现方案（整系统设计，各模块硬件架构、关键器件选型等）；\n" +
          "2.\t根据设计方案，完成硬件原理图设计，指导PCB工程师完成PCB布局&布线、检查审核等工作；\n" +
          "3.\t开展硬件单板&整机调试、测试、认证等工作； \n" +
          "4.\t整理输出硬件相关生产资料，配合NPI完成新品导入等工作； \n" +
          "5.\t维护已量产项目，对产品进行持续优化与改进； \n" +
          "6.\t牵头解决各环节出现的各类硬件异常问题。",
        demand: "1.\t本科以上学历，电子信息、通信射频、自动化等相关专业;\n" +
          "2.\t10年以上硬件设计工作经验，有成功量产和产品标准化方面经验；\n" +
          "3.\t从事过复杂电磁环境的工业级/汽车级产品者优先； \n" +
          "4.\t对SI、PI、EMC有较深入理解，一定的EMC设计整改经验；\n" +
          "5.\t熟悉使用Cadence等常用设计软件；"
      },
      {
        id: "s4",
        name: "初级硬件工程师",
        area: "北京",
        edu: "本科",
        station: "研发",
        duty: "1.负责单板硬件原理图设计、元器件选型、PCB设计，BOM文件整理及按要求编写相关文档；\n" +
          "2.负责单板及整机硬件调试；\n" +
          "3.协助软件工程师整机联调并解决产品中的问题点\n" +
          "4.配合导产组完成样机的试制及量产工作，并撰写相关的技术文档；\n" +
          "5.解决产品中遇到的EMC问题。",
        demand: "1.通信、电子、自动化及相关专业，全日制本科及以上学历，三年以上硬件设计经验；\n" +
          "2.具有良好的数字电路、模拟电路，熟悉ARM嵌入式平台硬件开发，熟悉常用外围接口电路设计（SPI/I2C/UART/RS485/CAN/USB等\n" +
          "3.有ARM/FPGA/DSP嵌入式系统板级硬件设计和调试经验；\n" +
          "4.熟悉产品设计中的EMC、对信号完整性及产品可靠性设计有一定的认识；\n" +
          "5.熟练使用CADENCE/PADS软件工具，具有高速、高密度、多层PCB板设计经验；\n" +
          "6.能够独立完成硬件设计及调试，具备焊接能力、熟练使用万能表、示波器等仪器；\n" +
          "7.了解产品设计中的工艺要求；"
      },
      {
        id: "s5",
        name: "流媒体开发工程师",
        area: "北京",
        edu: "本科",
        station: "研发",
        duty: "1.负责无人机流媒体系统的设计、开发与维护，确保系统的低延迟、高可用性、高性能和稳定性。​\n" +
          "2.参与音视频编解码、传输协议等核心技术的研究与优化，提升流媒体服务质量。​\n" +
          "3.与产品团队紧密合作，根据业务需求完成功能迭代与系统升级。​\n" +
          "4.分析和解决流媒体系统运行过程中出现的技术问题，提供有效的解决方案。",
        demand: "1.本科及以上学历，计算机科学与技术、电子信息工程、通信工程等相关专业；\n" +
          "2.扎实掌握计算机网络、数据结构、算法分析等基础知识；\n" +
          "3.精通 C/C++或 Java 其中至少一种编程语言，具备良好的代码编写习惯与编程思维；\n" +
          "4.深入理解 H.264、H.265、AAC 等音视频编解码标准，熟悉 RTP、RTCP、RTMP、HLS、WebRTC 等流媒体传输协议；\n" +
          "5.熟练使用 FFmpeg、GStreamer、SRS 、vlc、ZLMediaKit、mediasoup等至少一种流媒体开源框架，能够进行二次开发与定制；\n" +
          "6.具备扎实的网络编程基础，熟悉 TCP/IP 协议栈，有 Socket 编程经验，能处理网络通信中的常见问题；\n" +
          "7.熟悉linux、windows、android、ios平台环境下的音视频SDK开发；\n" +
          "8.做过直播推、拉流，点播，后台转码等业务开发，熟悉直播、点播架构及相关策略；\n" +
          "9.了解 webrtc 框架，了解neteq、pacing、gcc等，做过rtc相关开发；"
      },
      {
        id: "s6",
        name: "机械结构工程师",
        area: "北京",
        edu: "本科",
        station: "研发",
        duty: "1、负责无人机整机及部件级结构设计，内部航电堆叠等；\n" +
          "2、负责无人机的承力结构、功能结构设计；\n" +
          "3、负责无人机结构相关的测试、试验工作；\n" +
          "4、负责编制结构设计相关技术文档、图纸及EBOM；\n" +
          "5、负责对所设计结构进行生产跟进，解决生产及调试过程中出现的问题，保证项目正常推进；",
        demand: "1、飞行器设计、机械设计制造/机电一体化、自动化等相关专业，本科及以上学历，有飞行器结构设计相关工作经验者优先；\n" +
          "2、掌握飞机结构设计相关知识，熟悉无人机的结构形式；\n" +
          "3、熟悉无人机研发流程，能独立完成无人机相关结构件设计及标准件选型工作，具有无人机产品开发经验者优先；\n" +
          "4、熟悉掌握机械制图、公差配合、材料选型、表面处理、热处理等基础知识；\n" +
          "5、熟悉常用设计软件，Cro/E、Solidworks、AutoCAD等，能进行基本的力学强度校核；"
      },
      {
        id: "s7",
        name: "产品技术支持工程师",
        area: "北京",
        edu: "本科",
        station: "",
        duty: "1.专业知识：\n" +
          "1）具备扎实的无人机专业知识，对无人机的原理、性能、应用场景等有深入了解。\n" +
          "2）熟悉低空经济相关政策，能够敏锐捕捉政策动态并快速分析其对业务的影响。\n" +
          "3）熟悉招投标相关法律法规和流程，了解无人机行业招投标特点与要求。\n" +
          "2.技能要求：\n" +
          "1）拥有优秀的文档整理与输出能力，能够将政策解读、行业信息、招投标文件等以清晰、准确的文档形式呈现。\n" +
          "2）具备出色的沟通能力，尤其是英文沟通能力，能够用英文流畅地与海外客户交流，包括在商务洽谈过程中与国际客户沟通相关条款等。\n" +
          "3）熟练掌握项目交付流程，有责任心，能够确保交付环节的顺利进行。\n" +
          "4）擅长招投标文件的制作，包括商务标和技术标，能够准确理解招标要求，突出公司产品优势，提高中标率。",
        demand: "1.工作经验：\n" +
          "1）有 1 年以上无人机行业相关工作经验，熟悉售前支持、项目交付及招投标流程者优先。\n" +
          "2）学历：硕士以上学历，有海外项目交付或客户维护经验，以及成功的无人机行业招投标经验者更佳。\n" +
          "2.其他素质：\n" +
          "1）具备良好的适应能力，能够快速跟踪政策变化以及招投标市场动态。\n" +
          "2）具备较强的分析和解决问题的能力，能够在招投标过程中应对各种突发情况。"
      },
      {
        id: "s8",
        name: "行业销售经理",
        area: "北京",
        edu: "大专",
        station: "销售",
        duty: "1.独立开拓公司无人机行业市场，开发、维护和挖掘销售机会；\n" +
          "2.根据公司市场营销战略，积极完成销售量指标，扩大产品市场占有率；\n" +
          "3.搭建政企合作关系，开拓维护经销商；\n" +
          "4.协调公司内部资源，做好客户公关，与客户保持良好沟通，深度挖掘客户，为客户提供主动、热情、满意、周到的服务；\n" +
          "5.根据公司产品价格体系及市场策略，处置询盘、报价、合同条款的协商及合作通签订事宜；\n" +
          "6.把握市场，随时向公司提供市场分析及预测报告。",
        demand: "1.大专及以上学历，具备2年以上的工业产品、高科技产品销售经验；\n" +
          "2.较强的同行业信息收集获取能力，擅长商务拓展、谈判、执行力强；\n" +
          "3.对无人机及无人机知识、技能及行业应用比较熟悉者优先；\n" +
          "4.具有公安、消防、测绘、电力、石油、海事、军警背景资源者优先录用；\n" +
          "5.热爱无人机行业。"
      },
      {
        id: "s9",
        name: "飞行工程师",
        area: "北京",
        edu: "大专",
        station: "飞手",
        duty: "1. 带领飞行小队，使用油动中型复合翼无人机搭载多种任务载荷完成应急场景下的救灾任务。\n" +
          "2. 与应急管理部门共同制定无人机运维管理规范、应急演练方案、日常训练方案等。\n" +
          "3. 培训政府部门或合作伙伴飞手，使其具备操控中型复合翼无人机的飞行能力。\n" +
          "4. 负责无人机及其搭载设备的日常维护、检查和保养工作，确保设备处于良好运行状态。\n" +
          "5. 收集、整理和分析飞行数据，为优化飞行任务和设备性能提供依据。\n" +
          "6. 参与无人机飞行任务的规划和设计，提出合理的建议和改进方案。\n" +
          "7. 在执行任务过程中，及时处理突发技术问题，保障飞行安全和任务顺利完成。\n" +
          "8. 协助相关部门进行无人机飞行任务的风险评估和安全管理工作。\n" +
          "9. 按照规定流程和要求，负责无人机飞行的空域申请和安全报备等相关工作。",
        demand: "1. 具备航空相关专业背景，如航空工程、飞行器设计等，或具有丰富的中型无人机飞行经验。\n" +
          "2. 熟悉无人机的飞行原理、结构组成和操控系统，能够熟练处理各种飞行状况。\n" +
          "3. 具备良好的团队协作能力，能够有效地领导飞行小队完成任务。\n" +
          "4. 具备扎实的航空法规知识，熟悉空域申请流程和安全报备要求。\n" +
          "5. 能够熟练使用相关软件对飞行数据进行收集、整理和分析。\n" +
          "6.持有有效的IV类垂直起降无人机驾驶执照，且有中型复合翼无人机的飞行操作经验者优先。"
      },
      {
        id: "s10",
        name: "装配工程师",
        area: "北京",
        edu: "大专",
        station: "",
        duty: "1. 按照无人机标准工艺流程进行产品装配；\n" +
          "2. 解决装配中电路、结构等简单问题；\n" +
          "3. 解决装配中线缆细节的结构连接问题。",
        demand: "1.熟练掌握线缆、元器件焊接工艺；\n" +
          "2.有电子产品组装、布线基础；\n" +
          "3.有无人机类产品装配经验者优先；"
      }
    ]

  },
  'join_index': {
    'text1': '概览',
    'text2': '社会招聘',
    'text3': '校园招聘',
    'text4': '为了邀你加入',
    'text5': '我们每年飞行了上百万公里',
    'text6': '“有梦想、有活力、有激情、勇于创新”',
    'text7': '航翊科技由一群“有梦想、有活力、有激情、勇于创新”的年轻人组成',
    'text8': '“尊重、包容、发展”',
    'text9': '我们秉承“尊重、包容、发展”人才理念，努力为每一位加入我们的优秀人才提供施展才华的平台',
    'text10': '成为我们的一员',
    'text11': '我们一直在寻找“有梦想、有活力、有激情、勇于创新”的伙伴结伴同行，欢迎您的加入！',
    'text12': '校园招聘',
    'text13': '社会招聘',
  },
  'join_social': {
    'text1': '概览',
    'text2': '社会招聘',
    'text3': '校园招聘',
    'text4': '社招职位',
    'text5': '简历请发送至： hr@hovwing.com',
    'jobList': [
      {
        'id': "s1",
        'hot': 1,
        'name': "制导与控制算法工程师"
      },
      {
        'id': "s8",
        'hot': 1,
        'name': "3D视觉设计师"
      },
      {
        'id': "s6",
        'hot': 1,
        'name': "行业销售经理"
      },
      {
        'id': "s4",
        'hot': 0,
        'name': "嵌入式Linux软件开发工程师"
      },
      {
        'id': "s12",
        'hot': 0,
        'name': "通信FPGA工程师"
      },
      {
        'id': "s11",
        'hot': 0,
        'name': "地面站软件开发工程师"
      },
      {
        'id': "s2",
        'hot': 0,
        'name': "Web前端开发工程师"
      },
      {
        'id': "s3",
        'hot': 0,
        'name': "Java后端开发工程师"
      },
      {
        'id': "s5",
        'hot': 0,
        'name': "软件测试工程师"
      },
      // {
      //   id: "s7",
      //   hot: 0,
      //   name: "售前技术支持工程师"
      // },
      {
        'id': "s10",
        'hot': 0,
        'name': "飞行工程师"
      },
      {
        'id': "s9",
        'hot': 0,
        'name': "装配工程师"
      },
      {
        'id': "s00",
        'hot': 0,
        'name': "更多职位请电话咨询"
      }
    ]
  },
  'support': {
    'text1': '帮助与支持',
    text2: '感谢您一直以来对我们的关注和支持，我们非常乐意就您在无人机选型、使用、维护中的问题提供帮助',
    text3: '告诉我们您遇到的问题',
    text4: '售后服务中心',
    text5: '7天 x 24技术支持',
    text6: '售后服务中心地址',
    text7: '北京市海淀区华胜天成科研大楼一层东侧101-102',
  },
  'contactNew': {
    'text1': '联系我们',
    'text2': '我们可以提供',
    'text3': '提供更多关于航翊科技和航翊科技无人机的介绍',
    'text4': '为您提供合适的解决方案',
    'text5': '协助您推进项目',
    'text6': '提供产品报价',
    'text7': '联系方式',
    'text8': '电话',
    'text8_1': '010-50947771',
    'text9': '（北京时间 周一至周五，09:00-18:00）',
    'text10': '刘经理 +86 15210115202',
    'text11': '刘经理 +86 15210115202',
    'text12': '刘经理 +86 15210115202',
    'text13': '刘经理 +86 15210115202',
    'text14': '邮箱',
    'text15': '公司地址',
    'text16': '北京市海淀区华胜天成科研大楼一层东侧101-102',
    'text17': '姓名',
    'text18': '邮箱',
    'text18_1': 'sales@hovwing.com',
    'text19': '电话',
    'text20': '公司',
    'text21': '区域',
    'text22': '留言',
    'text23': '提交此表单即表示您接受我们的',
    'text24': '隐私政策',
    'text25': '和',
    'text26': '使用条款',
    'text27': '提交',
    'text28': '提交成功',
    'text28_1': '感谢您的反馈',
    'text29': '请填写姓名',
    'text30': '请填写邮箱',
    'text31': '请填写电话',
    'text32': '请填写公司',
    'text33': '请填写区域',
    'text34': '请填写留言',
  },
  'termsConditions': {
    'text1': '条款和条件',
    'text2': '所有航翊科技网站均归航翊科技（北京航翊科技有限公司）所有，是依据中华人民共和国法律成立的有限责任公司，总部位于北京市海淀区华胜天成科研大楼一层东侧101-102。',
    'text2_1': '法定代表人陈一峰先生。',
    'text3': '接受使用条款',
    'text4': '通过访问和使用任何航翊科技的网站，您同意受当前使用条款的约束，此处引用的所有条款和条件或任何网站上规定的任何附加条款和所有此类条款均视为您接受。如果您不同意目前的使用条款，则不应使用本网站或任何航翊科技网站。',
    'text5': '这些使用条款可随时由航翊科技修改。此类修改后的使用条件应在本网站或任何其他航翊快捷网站上发布时生效。请定期查看我们网站上发布的使用条款，以确保您了解管理您使用这些网站的所有条款。其他航翊科技网站可能有自己的使用条款，适用于此类网站。此外，特定条款和条件可能适用于本网站包含或通过本网站提供的特定内容，产品，材料，服务或信息。此类特定条款可能是这些使用条款的补充，或者，只要这些特定条款的内容或意图与这些使用条款中包含的条款不一致，此类特定条款将取代这些使用条款。',
    'text6': '航翊科技保留随时更改或更新网站内容或其格式的权利，恕不另行通知。航翊科技保留自行决定以任何理由终止或限制访问任何网站的权利。',
    'text7': '隐私政策',
    'text8': '通过任何航翊科技网站收集和处理个人信息均符合我们的隐私政策和数据保护法规。有关更多详细信息，请参阅我们的',
    'text8_1': '《隐私政策》',
    'text9': '知识产权',
    'text10': '航翊科技名称和徽标是航翊科技的注册商标。航翊科技的产品和配件受到知识产权和工业产权的保护，包括商标，模型和专利。任何航翊科技网站（包括模型，图画，照片，文本，音频，视频和图形）内容的版权和所有其他所有权均属于航翊科技或其许可方的唯一财产，其中使用或发布内容的任何部分是经许可的。所有其他不属于航翊科技的商标和徽标均为其各自所有者的财产。',
    'text11': '在我们网站上发布的照片受版权保护，并且是其各自所有者的财产。',
    'text12': 'www.hovwing.com网站上发布的内容可以未经修改的形式使用，其唯一目的是由这些网站的注册和批准成员根据许可协议操作航翊科技产品。',
    'text13': 'www.hovwing.com网站上发布的内容可以未经修改的形式复制或分发，仅供这些网站的注册和批准成员使用或支持服务使用。此内容的商业使用或支持服务使用仅在航翊科技授权的情况下才能满足航翊科技和航翊科技经销商的利益。严禁将此内容从其最初目的中贪污。',
    'text14': '除另有规定外，任何航翊科技网站上发布的任何内容均可以未经修改的形式复制或分发，仅用于个人非商业用途。未经航翊科技事先书面同意，严禁以任何其他方式使用内容，包括但不限于分发，复制，修改，显示，翻译，改编或传播。',
    'text15': '所有复制品均应保留所有版权和其他所有权声明。',
    'text16': '免责声明',
    'text17': '虽然我们已尽最大努力确保在任何航翊科技网站上发布的信息的准确性，包括其内容和功能，但在法律允许的最大范围内，“按原样”提供任何内容。因此，您自行承担使用任何网站的风险。在此，我们明确拒绝任何明示或暗示的陈述或保证，包括但不限于适销性，适用于任何特定用途，不侵权或其网站或其内容的运营的保证。对本网站的安全性，我们不保证或做出任何陈述。您承认任何可能被截获的信息。',
    'text18': '在任何情况下，任何情况下均不得对任何间接，间接，惩罚性，特殊或附带的损害（包括但不限于对业务损失，合同，收入，数据，信息或业务中断造成的损害）承担责任，因此，由于使用或无法使用其网站或其内容而引起或与之相关，即使已经被告知此类损害的可能性也是如此。任何对其网站感兴趣或与其网站相关的行为必须在作出行动的原因之后的一（1）年内以书面形式发出并通知。由于某些司法管辖区不允许排除或限制后果性或附带性损害，因此前一句的部分或全部内容可能对您不适用。',
    'text19': '航翊科技网站可能包含指向不受航翊科技控制的其他网站的链接。此类链接仅为方便起见而提供给您，航翊科技对任何此类链接网站的内容或功能不承担任何责任。航翊科技对所有此类链接网站的内容和功能的准确性，合法性，可靠性或有效性不做任何明示或暗示的保证。航翊科技另外既不认可也不推荐任何此类链接网站。',
    'text20': '联系方式',
    'text21': '如果您想了解航翊科技的更多情况、修改您的个人数据或对本声明有任何问题、评论、建议，或者需要对您的个人数据提出要求通过电子邮箱hoverwing@hovwing.com与我们联系。',
    'text22': '重要提示：鉴于当地法律和语言差异，当地语言版本的《隐私政策》可能与本版本有所不同。如果出现任何差异，请以当地语言版本为准。',
    'text23': '最近更新时间：2023年12月18日',
  },
  'privacyPolicy': {
    'text1': '隐私政策',
    'text2': '北京航翊科技有限公司是依据中华人民共和国法律成立的有限责任公司（以下简称“航翊科技”“我们”和“我们的”，包括其母公司、子公司、关联公司等）。我们重视维护和保护用户的个人信息。您在使用航翊科技的产品、服务时，我们可能会收集和使用您的个人信息。本《隐私政策》旨在向您说明我们如何收集、储存、使用或分享您的个人信息。希望您仔细阅读本《隐私政策》，以便在需要的时候，能让您作出合适的选择。',
    'text3': '您使用或继续使用我们的产品或服务，即意味着您同意我们按照本《隐私政策》收集、储存、使用和分享您的个人信息。',
    'text4': '个人信息收集',
    'text5': '您通过使用航翊科技的产品或服务的过程中提供给航翊科技的信息，如姓名、电话号码、电子邮箱地址、通讯地址、身份证号码、银行卡卡号（当您在航翊科技进行付款交易时需提供）、飞行数据（包括传感器数据、导航系统数据、设备数据、控制类数据、限飞数据和环境感知视觉数据，当您要求航翊科技提供售后服务时需提供）等。您使用我们的产品或服务时系统读取或储存的信息，如您的位置、产品使用的日志记录、您的电子设备的配置信息、飞行数据、接入我们产品或服务的IP地址、时间信息、地理环境和位置信息、分享的文字或图片等。',
    'text6': '您的个人信息中可能含有敏感信息，例如您的种族、宗教信仰、个人健康状况、性别取向等，您在使用我们产品或服务时，您可能会在公开渠道上传或发布这类敏感信息。请您谨慎地处理这类敏感信息。',
    'text7': '信息共享和披露',
    'text8': '我们收集到的您的个人信息将可能被我们用于实现如下目的：',
    'text9': '向您提供服务。帮助我们设计新产品或新服务，改善我们现有的产品或服务。用于身份识别、客户服务、安全防范、存档或备份等。向您提供与您更加密切相关的广告。让您参与我们的产品或服务调查。我们可能委托其他第三方代表航翊科技提供服务，比如数据处理、账目管理及市场营销。我们仅向这些第三方提供其完成服务所必须的信息，并且我们以航翊科技遵循的同等保密标准与这些第三方签署保密协议。这些第三方可能来自境外，根据其所在地的法律，这些境外第三方可能负有一定的信息披露义务。我们不会与航翊科技以外的任何第三方分享您的个人信息，但以下情况除外：',
    'text10': '在得到您同意的情况下： 为实现“我们可能如何使用您的个人信息？”章节中的目的而向航翊科技授权的产品或服务提供商分享您的信息。 在航翊科技内部分享您的个人信息以便实现“我们可能如何使用您的个人信息？”章节中的目的。',
    'text11': '今后我们可能出售航翊科技业务或并购新业务，在此情况下，您的个人信息及相关账目、您购买的产品及服务等，将随着业务一并转移。',
    'text12': '您的个人信息在如下情况下可能会被强制要求披露：1）在涉嫌犯罪活动时，向司法或执法机构披露以侦查预防犯罪；2）根据法律（或法院）的强制要求披露；3）根据政府的强制要求披露；4）为保护航翊科技的资产（例如清偿逾期账款）等。在上述情况下，我们将记录信息披露的内容、时间、原因及对象。',
    'text13': '您的权利',
    'text14': '如果您想查阅或验证您的个人信息，以及查看我们的披露记录时，请联络我们的客户经理或经销商。若在某些情况下我们无法提供相关资料，我们将及时告知您原因。',
    'text15': '在某些情况下您有权选择拒绝向我们提供某些信息，但我们可能因此无法向您提供某些产品、服务或信息。为保护双方利益，例如为确保您的要求被执行、为证明我们向您提供了所需信息，我们可能监控您与航翊科技的电话或邮件往来，以保证我们的服务质量。',
    'text16': '如果您不希望接收到我们关于直接营销的沟通，请告知我们，我们将会在直接营销名单中删除您的个人信息。',
    'text17': '如果您不希望我们在航翊科技成员中分享您的个人信息，请通知我们。在此情况下，我们由于信息缺失而有可能无法向您提供特定的产品或服务。',
    'text18': '如果您未满十八岁，您应该获得父母或监护人的同意和指导以确保正确使用我们的产品和服务。',
    'text19': '根据您所处的地域的法律规定，本《隐私政策》的某些条款可能并不适用于您。本《隐私政策》不排除或限制您根据本地法律规定所享有的任何权利。',
    'text20': 'Cookie',
    'text21': '当您访问我们的网站时，文件将被放置在您的终端上。这些文件称为cookie，旨在收集有关您浏览的信息，并使我们能够关注您的需求和期望。例如，我们使用Cookie来识别您并访问您的my. hovwing帐户。',
    'text22': '本部分允许您更好地了解Cookie的工作方式以及如何使用当前工具进行配置。',
    'text23': '本隐私政策的变更',
    'text24': '我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。',
    'text25': '我们的承诺',
    'text26': '航翊科技非常感谢能有机会为您提供产品和服务。自航翊科技成立至今，赢得并保持您的信任始终是我们的服务宗旨。我们承诺尊重及保护您提供的隐私及个人信息，也希望您能了解我们的隐私保护政策，包括如何采集、使用及披露您的个人信息。',
    'text27': '我们指定专门的团队负责管理您的个人信息保护，包括制度、纠纷解决、培训、联络等各方面，并直接向董事会及总经理汇报隐私保护相关事项。',
    'text28': '我们将确保在您申请任何产品或服务时，获知上述信息采集目的。如果我们希望将您的个人信息用于其他目的，我们将向您提出申请。',
  },
  'notfound': {
    'text1': '页面走丢了',
    'text2': '返回首页',
  },


  // v2
  fayj:{
    text1:'应急',
    text2:'解决方案',
    text3:'应用案例',
    list1:[
      {
        title:'行业痛点',
        info:['高山峡谷、“三断”场景下，通信能力弱易造成中断','应急事件对救援时效性要求高，需要迅速反应','应急信息沟通不畅，容易形成”信息孤岛“']
      },
      {
        title:'方案优势',
        info:['中型复合翼无人机可以搭载光电吊舱、机载卫通等载荷，可以快速搭建空中通信“生命线”，打通“通信孤岛“','中型复合翼无人机具备垂直起降、覆盖距离远、续航时间长的特点，更加具备应急救援首达能力','灾区实时画面可接入应急指挥统一协调平台，现场视频画面可24小时在线直播，为救援提供关键信息支撑']
      }
    ],
    list2:[
      {
        url:'/static/images/v2/hyfa/fa_fly.png',
        title:'中型复合翼无人机飞行平台',
        info:['ZT-120V','ZT-60V','ZT-25V','ZT-16V','ZT-13V','ZT-25V','ZT-60VS']
      },
      {
        url:'/static/images/v2/hyfa/fa_rj.png',
        title:'软件产品',
        info:['巡检助手','云巡','Dowell']
      },
      {
        url:'/static/images/v2/hyfa/fa_rwzh.png',
        title:'任务载荷',
        info:['光电吊舱','测绘相机','机载PDT集群基站','激光雷达','机载公网基站','机载人员搜救载荷','机载卫通设备','快速三维建模载荷']
      },
    ],
    list3:[
      {
        url:'/static/images/v2/hyfa/yj_al1.png',
        title:'9.6海南台风“摩羯”应急救援',
        info:'2024年9月6日16时20分，超强台风“摩羯”在海南省文昌市沿海地区登陆。9月7日，ZT-120V中型复合翼无人机搭载三网通公网基站，在空中风速8级的情况下，在海口市定安县甲子机场起飞，飞往海口市三江镇，为灾区救援提供应急通信、灾情侦察保障，成为抗击超强台风“摩羯”的首达救援力量。救援期间，ZT-120V中型复合翼无人机出动3个架次，累计飞行保障622分钟，累计飞行航程987千米、公网覆盖面积约785平方公里、激活用户数3310人次、成功呼叫434人次、下行流量6072.95M、上行流量2454.28M，并将灾区视频画面实时回传至海南省应急管理厅航空应急救援指挥调度平台，为广大群众的应急通信和指挥部的决策部署提供关键支撑。'
      },
      {
        url:'/static/images/v2/hyfa/yj_al2.png',
        title:'四川省甘孜藏族自治州雅江县河口镇城厢村发生森林火灾',
        info:'2024年12月9日，四川省甘孜藏族自治州雅江县河口镇城厢村发生森林火灾。火灾发生后，ZT-120V无人机救援团队立即启动应急响应，迅速奔赴参与救援，成为抵达火场上空的首支复合翼无人机救援力量。救援期间，ZT-120V中型复合翼无人机挂载机载卫通设备和光电吊舱，从距火场40km外的新都桥镇起飞，累计出动2个架次，累计飞行保障390分钟，在海拨5000m的高度对火场进行空中勘察、巡查，对着火面积20km²内的区域进行巡视，火场现场画面和红外视频画面实时回传至四川省应急管理厅航空应急救援指挥调度平台，为指挥部全面了解掌握火场态势、科学指挥决策、高效安全灭火提供关键信息支撑。'
      },
    ],
  },
  fany:{
    text1:'能源',
    text2:'解决方案',
    text3:'应用案例',
    list1:[
      {
        title:'行业痛点',
        info:['需要面临极端温度、大风、降雨及降雪等恶劣环境条件','传统巡检方式无法突破时空限制，巡检效率低、成本高','传统巡检方式，数据采集不全面，缺乏有效的数据采集方式']
      },
      {
        title:'方案优势',
        info:['中型复合翼无人机具备抗风、抗雨雪天气的能力，可以在复杂气象环境下使用，并且能够在山区、河流、戈壁等多样化地形使用','中型复合翼无人机能够突破时空限制，可以24小时快速进行巡检作业，大幅提升巡检的工作效率','中型复合翼无人机搭载高分辨率摄像头和先进传感器，能够实现对电力设备的高精度监测，提供更详细、更全面的数据信息']
      }
    ],
    list2:[
      {
        url:'/static/images/v2/hyfa/fa_fly.png',
        title:'中型复合翼无人机飞行平台',
        info:['ZT-120V','ZT-60V','ZT-25V','ZT-16V','ZT-13V','ZT-25V','ZT-60VS']
      },
      {
        url:'/static/images/v2/hyfa/fa_rj.png',
        title:'软件产品',
        info:['巡检助手','云巡','Dowell']
      },
      {
        url:'/static/images/v2/hyfa/fa_rwzh.png',
        title:'任务载荷',
        info:['光电吊舱','测绘相机','机载PDT集群基站','激光雷达','机载公网基站','机载人员搜救载荷','机载卫通设备','快速三维建模载荷']
      },
    ],
    list3:[
      {
        url:'/static/images/v2/hyfa/ny_al1.png',
        title:'输电线路无人机防汛应急巡查',
        info:'国网通航使用中型复合翼无人机对安徽池州-九华重要输电线路开展无人机防汛应急巡查，这是国网公司首次采用中大型复合翼无人机开展电网防汛应急巡查任务，通过实时图传、机机中继等方式高效完成各类通道应急巡查任务，为电网安全稳定运行提供了强有力的保障。'
      },
      {
        url:'/static/images/v2/hyfa/ny_al2.png',
        title:'复合翼无人机执行4500米高海拔电网线路巡检',
        info:'大中型无人机高高原示范作业由国网通航公司与国网西藏检修公司联合开展。示范作业使用XXX复合翼无人机执行4500米高海拔电网线路巡检作业，对国网西藏电力的电力系统进行常规激光、夜间激光、灾情应急普查、红外巡视、红外夜巡等多个科目作业，实现了24小时全天候作业。此次作业刷新了国内外多个高原无人机的巡检记录。'
      },
    ],
  },
  falc:{
    text1:'林草',
    text2:'解决方案',
    text3:'应用案例',
    list1:[
      {
        title:'行业痛点',
        info:['林草场地环境复杂，人员难以快速到达现场，传统巡护方式存在监控盲区，不能实现全覆盖','林草场地范围广、山火隐患多、火灾防控难、灭火效率低、安全保障弱','传统巡检方式，巡护效率低，时效性差，无法实现有效巡护，收集数据单一且更新频率低']
      },
      {
        title:'方案优势',
        info:['中型复合翼无人机具备抗风、抗雨雪天气的能力，能够在山区、河流、高原等多样化地形使用，可实现对林草场地飞行全覆盖巡护，打通“通信孤岛“','中型复合翼无人机能够突破时空限制，巡检效率高，可搭载任务载荷，可获取实时高清可视画面，提高防火灭火效率','中型复合翼无人机搭载激光雷达，有效完成林草资源调查等测绘要求，搭载高、多光谱相机可实现地质调查、植被识别和分类、植被病虫害监测']
      }
    ],
    list2:[
      {
        url:'/static/images/v2/hyfa/fa_fly.png',
        title:'中型复合翼无人机飞行平台',
        info:['ZT-120V','ZT-60V','ZT-25V','ZT-16V','ZT-13V','ZT-25V','ZT-60VS']
      },
      {
        url:'/static/images/v2/hyfa/fa_rj.png',
        title:'软件产品',
        info:['巡检助手','云巡','Dowell']
      },
      {
        url:'/static/images/v2/hyfa/fa_rwzh.png',
        title:'任务载荷',
        info:['光电吊舱','测绘相机','机载PDT集群基站','激光雷达','机载公网基站','机载人员搜救载荷','机载卫通设备','快速三维建模载荷']
      },
    ],
    list3:[
      {
        url:'/static/images/v2/hyfa/lc_al1.png',
        title:'ZT-25V无人机执行某省林业和草原防火中心森林草原航空消防任务',
        info:'ZT-25V无人机执行某省林业和草原防火中心森林草原航空消防任务。在任务期间，ZT-25V无人机飞行633架次，飞行时长1020.93小时，巡护总作业面积738万亩，飞行总里程数约81680公里，累计巡护面积约22005万亩。'
      },
      {
        url:'/static/images/v2/hyfa/lc_al2.png',
        title:'ZT-25V无人机多次发现林区起火点',
        info:'ZT-25V无人机搭载专用摄像机，执行巡护监测任务实时传输影像信息，进行火情的智能识别及预警，为应急指挥中心决策部署提供依据，为林火扑救争取宝贵时间。巡护期间，ZT-25V无人机多次发现林区起火点和放牧人员、钓鱼人员、游泳人员、游玩车辆及野生动物等异常情况，并及时时向林场领导及工作人员汇报。'
      },
      {
        url:'/static/images/v2/hyfa/lc_al3.png',
        title:'根据森林和草原火灾风险普查的分析评估结果，结合全国林长制的全面落实',
        info:'根据森林和草原火灾风险普查的分析评估结果，结合全国林长制的全面落实，本次任务将森林草原火灾风险区域划分为标准方形格网，建立无人机网格巡护机制，并绘制了林场无人机航空防火巡护一张图，有效减少巡护盲区，提高巡护效率，有效改善了森林草原防火安全防范的能力和数字化水平。'
      },
    ],
  },
  faga:{
    text1:'公安',
    text2:'解决方案',
    text3:'应用案例',
    list1:[
      {
        title:'行业痛点',
        info:['面临治安形势复杂多变、警务资源配置不足，难以进行有效巡护与管理','巡护区域范围大，执法半径长，人员难以快速抵达','巡检数据采集单一后期利用率低，无法综合分析，追溯和审核历史数据困难']
      },
      {
        title:'方案优势',
        info:['无人机可以轻松飞越复杂地形和难以到达的区域，为治安防控提供了更为广阔的视野和全面的视角','无人机可以实现快速部署，能够大幅缩短从发现警情到响应的时间，并快速抵达现场','无人机可以快速勘查、摄录，固定现场证据，并通过挂载不同任务载荷，高空采集现场数据']
      }
    ],
    list2:[
      {
        url:'/static/images/v2/hyfa/fa_fly.png',
        title:'中型复合翼无人机飞行平台',
        info:['ZT-120V','ZT-60V','ZT-25V','ZT-16V','ZT-13V','ZT-25V','ZT-60VS']
      },
      {
        url:'/static/images/v2/hyfa/fa_rj.png',
        title:'软件产品',
        info:['巡检助手','云巡','Dowell']
      },
      {
        url:'/static/images/v2/hyfa/fa_rwzh.png',
        title:'任务载荷',
        info:['光电吊舱','测绘相机','机载PDT集群基站','激光雷达','机载公网基站','机载人员搜救载荷','机载卫通设备','快速三维建模载荷']
      },
    ],
    list3:[
      {
        url:'/static/images/v2/hyfa/ga_al1.png',
        title:'山东威海无人机城市常态化巡查应用',
        info:'山东威海市公安局特巡警支队城市漫游方案应用复合翼无人机进行“全域漫游基站+复合翼无人机”全域巡航。接到命令后，复合翼无人机3分钟内即可从特巡警支队起飞，20分钟内即可到达城市任何指定位置，解决了城市范围覆盖面积大、遮挡多，不利于巡查的难题，实现无人机全天候无死角监控，为指挥中心实时提供准确数据。'
      },
      {
        url:'/static/images/v2/hyfa/ga_al2.png',
        title:'苏州市相城区采用ZT-25V垂直起降固定翼无人机',
        info:'苏州市相城区采用ZT-25V垂直起降固定翼无人机，并设计江苏省首个警用垂起固定翼无人机机场，大幅缩短起飞前准备时间，通过一键启动，ZT-25V无人机可快速滑出机库、迅速起飞升空，赶到8公里外的现场，整个过程不到10分钟。通过巡飞20公里的主干道沿线实时回传的图像，指挥大厅现场警力开展交通疏导，很快疏通主路，并确保了早高峰的道路畅通，巡航区域从相城区拓展至苏州全域，实现远程可控、快速响应、高效联动。此外，ZT-25V无人机与警用无人机指挥作战方舱和各派出所多旋翼机组，组成警航“1+1+N”工作体系，极大提升了无人机警航战斗力。'
      },
    ],
  },
  fach:{
    text1:'测绘',
    text2:'解决方案',
    text3:'应用案例',
    list1:[
      {
        title:'行业痛点',
        info:['传统测绘方式受限，山区、峡谷、沼泽、森林等复杂地形环境难以抵达','大面积测绘耗时久，需要投入大量的人力、无力和时间','数据获取成本高，传统测绘方式，设备体积大、重量重，需要专业人员操控，成本高','数据精度和时效性不足，在动态变化的场景中，传统测绘方式很难做到及时更新数据']
      },
      {
        title:'方案优势',
        info:['无人机可以在短时间内完成组装、调试和起飞准备，能够在复杂地形环境快速部署和作业','无人机测绘可以快速覆盖大面积区域，大幅缩短测绘周期，降低项目运营成本','无人机可以搭载多种高精度的测绘传感器，获取高精度的三维地形数据和生成多种类型的数据成果','无人机可以定期进行测绘，获取动态变化的数据，确保数据的时效性。通过对这些数据的分析，可以及时发现潜在的安全隐患。']
      }
    ],
    list2:[
      {
        url:'/static/images/v2/hyfa/fa_fly.png',
        title:'中型复合翼无人机飞行平台',
        info:['ZT-120V','ZT-60V','ZT-25V','ZT-16V','ZT-13V','ZT-25V','ZT-60VS']
      },
      {
        url:'/static/images/v2/hyfa/fa_rj.png',
        title:'软件产品',
        info:['巡检助手','云巡','Dowell']
      },
      {
        url:'/static/images/v2/hyfa/fa_rwzh.png',
        title:'任务载荷',
        info:['光电吊舱','测绘相机','机载PDT集群基站','激光雷达','机载公网基站','机载人员搜救载荷','机载卫通设备','快速三维建模载荷']
      },
    ],
    list3:[
      {
        url:'/static/images/v2/hyfa/ch_al1.png',
        title:'长城实景三维建模',
        info:'某单位利用ZT系列复合翼无人机结合三维实景建模技术，可快速获取高精度（1cm分辨率）的长城三维数据，便于进一步开展长城保护和修缮工作。'
      },
      {
        url:'/static/images/v2/hyfa/ch_al2.png',
        title:'采用无人机倾斜摄影技术可以快速获取废弃矿山地理信息',
        info:'某单位采用无人机倾斜摄影技术可以快速获取废弃矿山地理信息，所生产的真三维模型能够快速获取低成本、高精度的矿山生态修复基础信息，为矿山废弃土地复垦和生态修复建设提供可靠的技术和数据支持。'
      },
    ],
  },
  fasl:{
    text1:'水利',
    text2:'解决方案',
    text3:'应用案例',
    list1:[
      {
        title:'行业痛点',
        info:['在地形复杂，如河流两岸的陡峭山坡、沼泽地带等，传统巡护方式，工作人员难以抵达','在遇到突发的河道污染、洪水等灾害事件时，传统的巡检方式难以及时发现并上报问题','传统巡护方式的效率限制，其定期巡检周期往往较长，无法及时掌握巡护区域短时间内的变化情况']
      },
      {
        title:'方案优势',
        info:['无人机能够飞越树林、山地、沼泽等复杂地形，大幅提升巡检的效率和覆盖范围','无人机在巡检过程中将采集到的数据实时传输回地面控制中心，使工作人员能够第一时间了解区域内的变化情况','无人机搭载任务载荷，可以进行精准的数据采集与分析，为后续的治理和维护提供有力的数据支持']
      }
    ],
    list2:[
      {
        url:'/static/images/v2/hyfa/fa_fly.png',
        title:'中型复合翼无人机飞行平台',
        info:['ZT-120V','ZT-60V','ZT-25V','ZT-16V','ZT-13V','ZT-25V','ZT-60VS']
      },
      {
        url:'/static/images/v2/hyfa/fa_rj.png',
        title:'软件产品',
        info:['巡检助手','云巡','Dowell']
      },
      {
        url:'/static/images/v2/hyfa/fa_rwzh.png',
        title:'任务载荷',
        info:['光电吊舱','测绘相机','机载PDT集群基站','激光雷达','机载公网基站','机载人员搜救载荷','机载卫通设备','快速三维建模载荷']
      },
    ],
    list3:[
      {
        url:'/static/images/v2/hyfa/sl_al1.png',
        title:'京杭大运河常州段常态化巡检',
        info:'某单位利用我公司复合翼无人机对京杭大运河常州段进行常态化巡检，利用可见光监控沿河违建，利用户外和光谱相机对水域污染情况进行综合监控，取得了良好成果。'
      },
      {
        url:'/static/images/v2/hyfa/sl_al2.png',
        title:'复合翼无人机承担苏州市内河道常态化巡检工作',
        info:'2020 年起，我公司复合翼无人机承担苏州市内河道常态化巡检工作，无人机挂载双光吊舱，可见光监控沿河违建，红外载荷监测偷排污染情况，取得了良好效果。'
      },
    ],
  },
  hw600:{
    text1:'无人直升机',
    text2:'载重',
    text3:'续航',
    text4:'图传',
    text5:'HW-600H\n' +
      '          是一款大载重长航时运输型无人直升机，动力系统采用自主可控油动发动机，机身采用纵列式布局，结构紧凑、载重效率高，航电设备采用三余度安全飞控，具备卫星导航和视觉融合导航双重导航体系，结合基于激光雷达的自主避障系统，全面保障飞行安全。',
    text6:'载重能力强',
    text7:'HW-600H 采用先进的动力系统，性能优越，动力强劲， 综合载荷能力达到200+kg。',
    text8:'续航时间久',
    text9:'HW-600H 采用纵列布局结构，旋翼升力更强，悬停效率更高，续航时间可达8小时。',
    text10:'重心范围大',
    text11:'HW-600H 旋翼采用一前一后布局，吊挂重心范围大，可以快速高效完成货物装卸作业。',
    text12:'自主感知避障',
    text13:'HW-600H 具备自主感知避障识别能力，保障无人机在全天候及复杂环境下的飞行安全。',
    text14:'抗干扰能力强',
    text15:'HW-600H 支持视觉惯导融合导航飞行模式，可在诱骗、信号受干扰或卫星拒止环境下保持安全飞行。',
    text16:'适航审定',
    text17:'HW-600H无人直升机已成功获得中国民用航空西南地区管理局的适航审定申请受理,HW-600H也是基于\n' +
      '            AP-21-71 适航审定管理程序申请并获受理的首款无人直升机,目前正在进行适航审定相关工作。',
    text18:'任务载荷',
    text19:'技术参数',
    taskLoad: [
      {
        title: "侦察载荷",
        list: [{
          name: 'GD3035',
          url: '/static/images/v2/600h/600h_logo1.png',
          url_load: '/static/images/v2/600h/600h_load1.png',
          info:['重量：0.70kg','可见光摄像头：30倍光学变焦','红外摄像头：非制冷氧化钒焦平面阵列','红外摄像头焦距：35mm']
        }, {
          name: 'GT3035L',
          url: '/static/images/v2/600h/600h_logo2.png',
          url_load: '/static/images/v2/600h/600h_load2.png',
          info:['重量：0.75kg','可见光摄像头：30倍光学变焦','红外摄像头：非制冷氧化钒焦平面阵列','红外摄像头焦距：35mm','激光测距：15~3000m','实时目标定位精度：<30m@1000m']
        }, {
          name: 'PT3075I',
          url: '/static/images/v2/600h/600h_logo3.png',
          url_load: '/static/images/v2/600h/600h_load3.png',
          info:['重量：2.90kg','可见光摄像头：30倍光学变焦','红外摄像头：非制冷氧化钒焦平面阵列','红外摄像头焦距：75mm','激光测距：50~6000m','实时目标定位精度：优于2m@1000m','内置高精度惯导模块']
        },]
      },
      {
        title: "消防载荷",
        list: [{
          name: '机载吊桶',
          url: '/static/images/v2/600h/600h_logo4.png',
          url_load: '/static/images/v2/600h/600h_load4.png',
          info:['最大容量：200L','释放流量：40L/S','取水方式：开放水源巡航取水']
        }, {
          name: '灭火水箱',
          url: '/static/images/v2/600h/600h_logo5.png',
          url_load: '/static/images/v2/600h/600h_load5.png',
          info:['最大容量：150L','喷射距离：20m','喷射方向：上下可调']
        }, {
          name: '专用灭火弹',
          url: '/static/images/v2/600h/600h_logo6.png',
          url_load: '/static/images/v2/600h/600h_load6.png',
          info:['总体重量：50kg','灭火弹类型：水基']
        },]
      },
      {
        title: "救援载荷",
        list: [{
          name: '机载喊话器',
          url: '/static/images/v2/600h/600h_logo7.png',
          url_load: '/static/images/v2/600h/600h_load7.png',
          info:['扩音功率：200w','功能：远距定向喊话']
        }, {
          name: '机载救援舱',
          url: '/static/images/v2/600h/600h_logo8.png',
          url_load: '/static/images/v2/600h/600h_load8.png',
          info:['最大承重：250kg','规格尺寸: 1500*1000*1000mm']
        }, {
          name: '机载照明灯',
          url: '/static/images/v2/600h/600h_logo9.png',
          url_load: '/static/images/v2/600h/600h_load9.png',
          info:['控制方式：遥控控制照明方向和亮度','照明时间：2h']
        },]
      },
      {
        title: "吊挂载荷",
        list: [{
          name: '机载抛投器',
          url: '/static/images/v2/600h/600h_logo10.png',
          url_load: '/static/images/v2/600h/600h_load10.png',
          info:['投放重量：200kg','挂点数量：10个','安全策略：异常状况自动抛投']
        }, {
          name: '物资运输箱',
          url: '/static/images/v2/600h/600h_logo11.png',
          url_load: '/static/images/v2/600h/600h_load11.png',
          info:['最大载重量：100kg']
        }, {
          name: '电动卷扬机',
          url: '/static/images/v2/600h/600h_logo12.png',
          url_load: '/static/images/v2/600h/600h_load12.png',
          info:['载重：100kg/150kg/200kg','绳长：30m/50m','升降速度：0.25-0.4m/s']
        },]
      },
    ],
    paramsList: [
      {
        title: "动力来源",
        info:'油电混合'
      }, {
        title: "机体尺寸",
        info:'3.38*1.51m'
      },{
        title: "巡航速度",
        info:'90km/h'
      },{
        title: "最大速度",
        info:'150km/h'
      },{
        title: "最大起飞重量",
        info:'650kg'
      },{
        title: "载荷能力",
        info:'300kg'
      },{
        title: "抗风等级",
        info:'15m/s'
      },{
        title: "最大飞行高度",
        info:'6000m'
      },{
        title: "最大起飞海拔",
        info:'5000m'
      },{
        title: "测控半径",
        info:'100km'
      },{
        title: "续航时间",
        info:'210min'
      },{
        title: "运输箱尺寸",
        info:'1.35*0.60*0.45m'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "运输箱尺寸",
        info:'支持安全飞行，支持视觉导航跟踪目标'
      },
    ]

  },
  hw25h:{
    text1:'复合翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:'HW-25H采用油电混动的驱动方式，载荷能力10kg，续航时间2小时，可搭配多种载荷，该无人直升机体积小、重量轻，机动灵活，能在复杂环境中完成测绘、侦察等作业任务',
    text5:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'定点悬停',
        info:'HW-25H能够在空中精确保持固定位置和高度，便于进行定点巡检、侦察等作业。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'低速巡航',
        info:'续航速度55km/h，低速巡航可对特定区域进行细致观察和作业，更好地完成任务。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'机动灵活',
        info:'体积小、重量轻，飞行姿态调整迅速，可快速改变飞行方向、高度和速度。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'安全性高',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'便于运输',
        info:'其小巧的机身和较轻的重量使得运输便利，可通过多种方式运输到任务地点'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'可搭载多种载荷',
        info:'根据不同任务需求，可搭载光电吊舱、激光雷达等多种载荷，实现作业任务'
      },
    ],
    paramsList: [
      {
        title: "动力来源",
        info:'油电混合'
      }, {
        title: "机体尺寸",
        info:'1.5*0.73m'
      },{
        title: "巡航速度",
        info:'55km/h'
      },{
        title: "最大速度",
        info:'90km/h'
      },{
        title: "最大起飞重量",
        info:'35kg'
      },{
        title: "载荷能力",
        info:'10kg'
      },{
        title: "抗风等级",
        info:'15m/s'
      },{
        title: "最大飞行高度",
        info:'6500m'
      },{
        title: "最大起飞海拔",
        info:'5000m'
      },{
        title: "测控半径",
        info:'50km'
      },{
        title: "续航时间",
        info:'120min'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  zt120v:{
    text1:'油电混动垂直起降固定翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:'可扩展控制范围',
    text5:'ZT-120V无人机是专为航空应急救援场景研发的行业领先产品，采用固定翼与多旋翼结合的复合翼布局。该无人机适配全套的应急场景载荷，可快速完成空中侦察和通信保障工作，具备全天候三维建模和快速成图能力，为应急救援工作提供强有力的支持和保障。\n',
    text6:'适航审定',
    text7:'2024年5月20日，远度科技ZT-120V无人机系统获得中国民用航空局颁发的民用无人驾驶航空器特殊适航证，成为首款获得特殊适航证的中型复合翼无人机。',
    text8:'任务载荷',
    text9:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局。既有垂直起降便利，又具备固定翼长航时的特点，续航时间达10小时。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'自组网数据链',
        info:'标配50——100km自组网数据链，无人机支持 “机-机中继”技术，传输距离可扩展至300km+。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'三余度安全飞控',
        info:'飞控系统采用三冗余设计，具备三套互相独立的传感器，三套传感器支持仲裁决策，互为备份。'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'多场景载荷能力',
        info:'载荷能力40kg，可搭载光电吊舱、激光雷达等多种载荷，实现多领域多场景应用。'
      },
    ],
    loadList:[{
      name:'光电吊舱',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    },{
      name:'激光雷达',
      url:'/static/images/v2/120v/120v_load_jgld.png'
    },{
      name:'快速三维建模载荷',
      url:'/static/images/v2/120v/120v_load_swjm.png'
    },{
      name:'机载PDT集群基站',
      url:'/static/images/v2/120v/120v_load_pdt.png'
    },{
      name:'机载人员搜救载荷',
      url:'/static/images/v2/120v/120v_load_sjzh.png'
    },{
      name:'机载宽带自组网设备',
      url:'/static/images/v2/120v/120v_load_zzw.png'
    },{
      name:'机载卫通设备',
      url:'/static/images/v2/120v/120v_load_jzwt.png'
    },{
      name:'机载公网基站',
      url:'/static/images/v2/120v/120v_load_gwjz.png'
    },],
    paramsList: [
      {
        title: "动力来源",
        info:'油电混合'
      }, {
        title: "机体尺寸",
        info:'6.50*3.26m'
      },{
        title: "巡航速度",
        info:'100km/h'
      },{
        title: "最大速度",
        info:'150km/h'
      },{
        title: "最大起飞重量",
        info:'150kg'
      },{
        title: "载荷能力",
        info:'40kg'
      },{
        title: "抗风等级",
        info:'15m/s'
      },{
        title: "最大飞行高度",
        info:'5500m'
      },{
        title: "最大起飞海拔",
        info:'3500m'
      },{
        title: "测控半径",
        info:'100+km'
      },{
        title: "续航时间",
        info:'600min'
      },{
        title: "运输箱尺寸",
        info:'2.34*1.44*1.37m'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  zt60vs:{
    text1:'油电混动垂直起降固定翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:'可扩展控制范围',
    text5:'ZT-60VS采用油电混动的驱动方式，载荷能力15kg，续航时间可达10小时，可搭配多种载荷，适用性强，配备三余度安全飞控，可有效保障飞行安全。',
    text6:'任务载荷',
    text7:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局。既有垂直起降便利，又具备固定翼长航时的特点，续航时间达10小时。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'自组网数据链',
        info:'标配50——100km自组网数据链，无人机支持 “机-机中继”技术，传输距离可扩展至300km+。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'三余度安全飞控',
        info:'飞控系统采用三冗余设计，具备三套互相独立的传感器，三套传感器支持仲裁决策，互为备份。'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'多场景载荷能力',
        info:'载荷能力15kg，可搭载光电吊舱、激光雷达等多种载荷，实现多领域多场景应用。'
      },
    ],
    loadList:[{
      name:'光电吊舱',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'正射相机',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'快速三维建模载荷',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'激光雷达',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      }],
    paramsList: [
      {
        title: "动力来源",
        info:'油电混合'
      }, {
        title: "机体尺寸",
        info:'4.80*2.65m'
      },{
        title: "巡航速度",
        info:'90km/h'
      },{
        title: "最大速度",
        info:'130km/h'
      },{
        title: "最大起飞重量",
        info:'78kg'
      },{
        title: "载荷能力",
        info:'15kg'
      },{
        title: "抗风等级",
        info:'15m/s'
      },{
        title: "最大飞行高度",
        info:'5500m'
      },{
        title: "最大起飞海拔",
        info:'3500m'
      },{
        title: "测控半径",
        info:'100+km'
      },{
        title: "续航时间",
        info:'600min'
      },{
        title: "运输箱尺寸",
        info:'1.85*0.47*1.15m \n' +
          '1.85*1.03*0.76m'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  zt60v:{
    text1:'复合翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:'ZT-60V采用纯电驱动方式，载荷能力15kg，续航时间达4小时，集便捷性、时效性、低成本于一体，综合能力出众',
    text5:'任务载荷',
    text6:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局，抗风能力15m/s，实用升限7000m。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'动平台起降+异地起降',
        info:'内置抗干扰传感器，支持在高速移动或复杂海况等非平稳状态下的起降，可支持100km以上异地起降。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'三余度安全飞控',
        info:'飞控系统采用三冗余设计，具备三套互相独立的传感器，三套传感器支持仲裁决策，互为备份。'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'多场景载荷能力',
        info:'载荷能力15kg，可搭载光电吊舱、激光雷达等多种载荷，实现多领域多场景应用。'
      },
    ],
    loadList:[{
      name:'光电吊舱',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'正射相机',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'快速三维建模载荷',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'激光雷达',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      }],
    paramsList: [
      {
        title: "动力来源",
        info:'长航时电池'
      }, {
        title: "机体尺寸",
        info:'4.80*2.65m'
      },{
        title: "巡航速度",
        info:'85km/h'
      },{
        title: "最大速度",
        info:'130km/h'
      },{
        title: "最大起飞重量",
        info:'68kg'
      },{
        title: "载荷能力",
        info:'15kg'
      },{
        title: "抗风等级",
        info:'15m/s'
      },{
        title: "最大飞行高度",
        info:'6500m'
      },{
        title: "最大起飞海拔",
        info:'5000m'
      },{
        title: "测控半径",
        info:'50+km'
      },{
        title: "续航时间",
        info:'240min'
      },{
        title: "运输箱尺寸",
        info:'1.85*0.47*1.15m \n' +
          '1.85*1.03*0.76m'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  zt25vs:{
    text1:'复合翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:'可扩展控制范围',
    text5:' ZT-25VS采用四旋翼加固定翼复合气动布局和油电混动的驱动方式，载荷能力8kg，续航时间达12小时，可满足长时间作业需求',
    text6:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局。既有垂直起降便利，又具备固定翼长航时的特点，续航时间达12小时。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'自组网数据链',
        info:'标配50——100km自组网数据链，无人机支持 “机-机中继”技术，传输距离可扩展至300km+。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'三余度安全飞控',
        info:'飞控系统采用三冗余设计，具备三套互相独立的传感器，三套传感器支持仲裁决策，互为备份。'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'多场景载荷能力',
        info:'载荷能力8kg，可搭载光电吊舱、激光雷达等多种载荷，实现多领域多场景应用。'
      },
    ],
    paramsList: [
      {
        title: "动力来源",
        info:'油电混合'
      }, {
        title: "机体尺寸",
        info:'4.00*2.06m'
      },{
        title: "巡航速度",
        info:'85km/h'
      },{
        title: "最大速度",
        info:'130km/h'
      },{
        title: "最大起飞重量",
        info:'40kg'
      },{
        title: "载荷能力",
        info:'8kg'
      },{
        title: "抗风等级",
        info:'15m/s'
      },{
        title: "最大飞行高度",
        info:'5500m'
      },{
        title: "最大起飞海拔",
        info:'3500m'
      },{
        title: "测控半径",
        info:'100+km'
      },{
        title: "续航时间",
        info:'720min'
      },{
        title: "运输箱尺寸",
        info:'1.56*0.63*0.82m'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  zt25v:{
    text1:'复合翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:' ZT-25V采用纯电驱动方式，载荷能力10kg，续航时间达4小时，具备时效性、便捷性、经济性及安全性的显著优势',
    text5:'任务载荷',
    text6:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局，采用纯电驱动，经济环保成本低。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'动平台起降+异地起降',
        info:'内置抗干扰传感器，支持在高速移动或复杂海况等非平稳状态下的起降，可支持100km以上异地起降。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'三余度安全飞控',
        info:'飞控系统采用三冗余设计，具备三套互相独立的传感器，三套传感器支持仲裁决策，互为备份。'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'多场景载荷能力',
        info:'载荷能力10kg，可搭载光电吊舱、激光雷达等多种载荷，实现多领域多场景应用。'
      },
    ],
    loadList:[{
      name:'光电吊舱',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'正射相机',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'快速三维建模载荷',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'激光雷达',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      },{
        name:'喊话器',
        url:'/static/images/v2/25v/25v_load_hhq.png'
      }],
    paramsList: [
      {
        title: "动力来源",
        info:'智能电池/长航时电池'
      }, {
        title: "机体尺寸",
        info:'4.13*1.93m'
      },{
        title: "巡航速度",
        info:'72km/h'
      },{
        title: "最大速度",
        info:'130km/h'
      },{
        title: "最大起飞重量",
        info:'38kg'
      },{
        title: "载荷能力",
        info:'10kg'
      },{
        title: "抗风等级",
        info:'15m/s'
      },{
        title: "最大飞行高度",
        info:'6500m'
      },{
        title: "最大起飞海拔",
        info:'5000m'
      },{
        title: "测控半径",
        info:'50+km'
      },{
        title: "续航时间",
        info:'240min'
      },{
        title: "运输箱尺寸",
        info:'1.56*0.63*0.82m'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  zt16v:{
    text1:'复合翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:' ZT-16V采用纯电驱动方式，载荷能力4kg，续航时间达3小时，整体机身采用模块化设计，可快速组装执行任务',
    text5:'任务载荷',
    text6:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局，采用纯电驱动，经济环保成本低。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'自组网数据链',
        info:'标配50——100km自组网数据链，无人机支持 “机-机中继”技术，传输距离可扩展至300km+。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'三余度安全飞控',
        info:'飞控系统采用三冗余设计，具备三套互相独立的传感器，三套传感器支持仲裁决策，互为备份。'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'动平台起降+异地起降',
        info:'内置抗干扰传感器，支持在高速移动或复杂海况等非平稳状态下的起降，可支持100km以上异地起降。'
      },
    ],
    loadList:[{
      name:'光电吊舱',
      url:'/static/images/v2/120v/120v_load_gddc.png'
    }
      ,{
        name:'正射相机',
        url:'/static/images/v2/60vs/60vs_load_zsxj.png'
      },{
        name:'快速三维建模载荷',
        url:'/static/images/v2/120v/120v_load_swjm.png'
      },{
        name:'激光雷达',
        url:'/static/images/v2/120v/120v_load_jgld.png'
      }],
    paramsList: [
      {
        title: "动力来源",
        info:'智能电池'
      }, {
        title: "机体尺寸",
        info:'3.38*1.57m'
      },{
        title: "巡航速度",
        info:'55km/h'
      },{
        title: "最大速度",
        info:'120km/h'
      },{
        title: "最大起飞重量",
        info:'20kg'
      },{
        title: "载荷能力",
        info:'4kg'
      },{
        title: "抗风等级",
        info:'13m/s'
      },{
        title: "最大飞行高度",
        info:'6500m'
      },{
        title: "最大起飞海拔",
        info:'4500m'
      },{
        title: "测控半径",
        info:'50+km'
      },{
        title: "续航时间",
        info:'180min'
      },{
        title: "运输箱尺寸",
        info:'1.35*0.60*0.45m'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  zt13v:{
    text1:'复合翼无人机',
    text2:'载荷能力',
    text3:'续航',
    text4:'  ZT-13V采用纯电驱动方式，载荷能力3kg，续航时间200分钟，最大航程180km，是一款专门适用于无人机场的无人机',
    text5:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局，采用纯电驱动，经济环保成本低。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'自组网数据链',
        info:'标配50——100km自组网数据链，无人机支持 “机-机中继”技术，传输距离可扩展至300km+。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      },{
        icon:'/static/images/v2/120v/120v_icon5.png',
        title:'三余度安全飞控',
        info:'飞控系统采用三冗余设计，具备三套互相独立的传感器，三套传感器支持仲裁决策，互为备份。'
      },{
        icon:'/static/images/v2/120v/120v_icon6.png',
        title:'动平台起降+异地起降',
        info:'内置抗干扰传感器，支持在高速移动或复杂海况等非平稳状态下的起降，可支持100km以上异地起降。'
      },
    ],
    paramsList: [
      {
        title: "动力来源",
        info:'智能电池'
      }, {
        title: "机体尺寸",
        info:'3.00*1.77m'
      },{
        title: "巡航速度",
        info:'55km/h'
      },{
        title: "最大速度",
        info:'100km/h'
      },{
        title: "最大起飞重量",
        info:'18kg'
      },{
        title: "载荷能力",
        info:'3kg'
      },{
        title: "抗风等级",
        info:'8m/s'
      },{
        title: "最大飞行高度",
        info:'5000m'
      },{
        title: "最大起飞海拔",
        info:'3000m'
      },{
        title: "测控半径",
        info:'50+km'
      },{
        title: "续航时间",
        info:'200min'
      },{
        title: "定位导航",
        info:'BDS、GPS、Galileo、Glonass / 支持单北斗'
      },{
        title: "GNSS拒止环境",
        info:'支持固定翼安全飞行，支持视觉导航跟踪目标'
      },
    ]
  },
  gddc:{
    text1:'产品中心_任务载荷_光电吊舱',
    list:[
      {
        type:0,
        title:'GD3035',
        name:'双光吊舱',
        info:['吊舱重量：≤800g','吊舱尺寸：H173mm*φ122mm','机械增稳：三轴机械增稳','俯仰范围：+45°～-135°','航向范围：360°* N','横滚范围：±60°','可见光相机：30倍光学变焦','红外相机：非制冷红外','定位精度：30m@1000m（CEP）'],
        position:0,
        urls:['/static/images/v2/gddc/GD3035_1.png','/static/images/v2/gddc/GD3035_2.png','/static/images/v2/gddc/GD3035_3.png','/static/images/v2/gddc/GD3035_4.png'],
        bg:'/static/images/v2/gddc/gddc_bg1.png',
      },
      {
        type:1,
        title:'GT3035L',
        name:'三光吊舱',
        info:['吊舱重量：≤1000g','吊舱尺寸：H173mm*φ122mm','机械增稳：三轴机械增稳','俯仰范围：+25°～-135°','航向范围：360°*N','横滚范围：±60°','可见光相机：30倍光学变焦','红外相机：非制冷红外','激光测距：20～3000m激光测距','定位精度：30m@1000m（CEP）'],
        position:0,
        urls:['/static/images/v2/gddc/GT3035L_1.png','/static/images/v2/gddc/GT3035L_2.png','/static/images/v2/gddc/GT3035L_3.png','/static/images/v2/gddc/GT3035L_4.png'],
        bg:'/static/images/v2/gddc/gddc_bg2.png',
      },
      // {
      //   type:1,
      //   title:'PT4075L',
      //   name:'40X三光吊舱',
      //   info:['吊舱重量：≤4kg','吊舱尺寸：H282mm*φ190mm','机械增稳：三轴机械增稳','俯仰范围：+45°～-135°','航向范围：360°* N','横滚范围：±48°','可见光相机：40倍光学变焦','红外相机：非制冷红外','激光测距：50～6000m激光测距','定位精度：30m@1000m'],
      //   position:0,
      //   urls:['/static/images/v2/gddc/PT4075L_1.png','/static/images/v2/gddc/PT4075L_2.png'],
      //   bg:'/static/images/v2/gddc/gddc_bg8.png',
      // },
      {
        type:1,
        title:'PD3035/PD30351',
        name:'高精度双光吊舱',
        info:['吊舱重量：≤1.6kg','吊舱尺寸：H200mm*φ135mm','机械增稳：三轴机械增稳','俯仰范围：+45°～-135°','航向范围：360°* N','横滚范围：±60°','可见光相机：30倍光学变焦','红外相机：非制冷红外','红外焦距：35mm','定位精度：30m@1000m（PT3035L）/3m@1000m（PT3035IL）','AI/AR：支持人、车、船、动物识别；支持AR信息叠加'],
        position:0,
        urls:['/static/images/v2/gddc/PD30351_1.png','/static/images/v2/gddc/PD30351_2.png'],
        bg:'/static/images/v2/gddc/gddc_bg5.png',
      },
      {
        type:1,
        title:'PT3035L/PT3035IL',
        name:'三光吊舱/高精度三光吊舱',
        info:['吊舱重量：≤1.6kg','吊舱尺寸：H200mm*φ135mm','机械增稳：三轴机械增稳','俯仰范围：+45°～-135°','航向范围：360°* N','横滚范围：±60°','可见光相机：30倍光学变焦','红外相机：非制冷红外','激光测距：20～3000m激光测距','定位精度：30m@1000m（PT3035L） /3m@1000m（PT3035IL）'],
        position:0,
        urls:['/static/images/v2/gddc/PT3035LPT3035IL_2.png','/static/images/v2/gddc/PT3035LPT3035IL_1.png','/static/images/v2/gddc/PT3035LPT3035IL_3.png','/static/images/v2/gddc/PT3035LPT3035IL_4.png'],
        bg:'/static/images/v2/gddc/gddc_bg3.png',
      },
      {
        type:0,
        title:'PT3075L/PT3075IL',
        name:'三光吊舱/高精度三光吊舱',
        info:['吊舱重量：≤3kg','吊舱尺寸：H272mm*φ180mm','机械增稳：三轴机械增稳','俯仰范围：+45°～-105°','航向范围：360°* N','横滚范围：±45°','可见光相机：30倍光学变焦','红外相机：非制冷红外','激光测距：50～6000m激光测距','定位精度：30m@1000m（PT3075L） /3m@1000m（PT3075IL）'],
        position:0,
        urls:['/static/images/v2/gddc/PT3075LPT3075IL_1.png','/static/images/v2/gddc/PT3075LPT3075IL_2.png','/static/images/v2/gddc/PT3075LPT3075IL_3.png','/static/images/v2/gddc/PT3075LPT3075IL_4.png'],
        bg:'/static/images/v2/gddc/gddc_bg4.png',
      },
      {
        type:1,
        title:'PD30275C',
        name:'变焦制冷红外双光吊舱',
        info:['吊舱重量：≤4kg','吊舱尺寸：H290mm*φ200mm','机械增稳：三轴机械增稳','俯仰范围：+45°～-135°','航向范围：360°* N','横滚范围：±50°','可见光相机：30倍光学变焦','红外相机：变焦制冷红外'],
        position:0,
        urls:['/static/images/v2/gddc/PD30275C_1.png','/static/images/v2/gddc/PD30275C_2.png'],
        bg:'/static/images/v2/gddc/gddc_bg5.png',
      },
      {
        type:1,
        title:'PT30275CL',
        name:'变焦制冷红外三光吊舱',
        info:['吊舱重量：≤5kg','吊舱尺寸：H290mm*φ220mm','机械增稳：三轴机械增稳','俯仰范围：+45°～-135°','航向范围：360°* N','横滚范围：±45°','可见光相机：30倍光学变焦','红外相机：变焦制冷红外','激光测距：6000m激光测距','定位精度：30m@1000m'],
        position:0,
        urls:['/static/images/v2/gddc/PT30275CL_1.png','/static/images/v2/gddc/PT30275CL_2.png'],
        bg:'/static/images/v2/gddc/gddc_bg6.png',
      },
      {
        type:1,
        title:'PT3035LD',
        name:'激光指示三光吊舱',
        info:['吊舱重量：≤3kg','吊舱尺寸：H265mm*φ172mm','机械增稳：三轴机械增稳','俯仰范围：+35°～-135°','航向范围：360°* N','横滚范围：±45°','可见光相机：30倍光学变焦','红外相机：非制冷红外','激光测距：150～10000m激光测距','定位精度：30m@1000m'],
        position:0,
        urls:['/static/images/v2/gddc/PT3035LD_1.png','/static/images/v2/gddc/PT3035LD_2.png'],
        bg:'/static/images/v2/gddc/gddc_bg7.png',
      },
    ]

  },
  chxj: {
    text1: '产品中心_任务载荷_测绘相机',
    list: [
      //
      {
        title:'1.25亿像素五镜头倾斜摄影相机',
        name:'',
        url:'/static/images/v2/chxj/chxj_1.png',
        bg:'/static/images/v2/chxj/chxj_bg1.png',
        info:['尺寸：140*140*125mm','重量：666g','工作温度：-20°C-65°C','相机供电：外部供电DC12-50V','相机接口：通用航插接口','有效像素：单镜头优于2500万像素，总>1.25亿像素','传感器：传感器尺寸:23.1*15.4mm','像元尺寸:3.76μm','图像尺寸：6144x4096 px','镜头焦距：倾斜35mm，正射25mm','存储容量：1280GB','拍照间隔：≥0.6s','参数调整：支持IS0，白平衡，色彩模式，快门速度等设置修改，支持蓝牙调参','数据速度：最快可达600M/s']
      },
      {
        title:'2.25亿像素全画幅五镜头倾斜摄影相机',
        name:'',
        url:'/static/images/v2/chxj/chxj_2.png',
        bg:'/static/images/v2/chxj/chxj_bg2.png',
        info:['尺寸：182*203*196 mm','重量：1280g','工作温度：-20°C-65°C','相机供电：外部供电DC12-50V','相机接口：通用航插接口','有效像素：单镜头4500万像素，总2.25亿像素','传感器：传感器尺寸:36*24mm','像元尺寸:4.4μm','图像尺寸：8192*5456 px','镜头焦距：倾斜56mm，正射40mm','存储容量：1280GB存储模块*2','拍照间隔：≥0.9s','参数调整：支持IS0，白平衡，色彩模式，快门速度等设置修改，支持蓝牙调参','数据速度：最快可达600M/s','云台角度：俯仰:-120°至+45°；横滚:±25°；平移:±160°']
      },
      {
        title:'6100X',
        name:'全画幅单镜头航测相机',
        url:'/static/images/v2/chxj/chxj_3.png',
        bg:'/static/images/v2/chxj/chxj_bg3.png',
        info:['尺寸：128*181*153 mm','重量：640g','工作温度：-20°C-65°C','相机供电：外部供电DC12-50V','相机接口：通用航插接口','有效像素：6100万像素','传感器：传感器尺寸:36*24mm','像元尺寸:3.76μm','图像尺寸：9552x 6368 px','镜头焦距：标配40mm，可定制56mm','存储容量：512GB','拍照间隔：≥1s','参数调整：支持IS0，白平衡，色彩模式，快门速度等设置修改，支持蓝牙调参','视频尺寸：4K(3860*2610)，30 fps','云台角度：俯仰:-130°至+45°；横滚:±55°；平移:±320°']
      },
      {
        title:'100M PRO V2',
        name:'1.02亿像素中画幅单镜头航测相机',
        url:'/static/images/v2/chxj/chxj_4.png',
        bg:'/static/images/v2/chxj/chxj_bg4.png',
        info:['尺寸：131*147*205mm','重量：900g','工作温度：-20°C-65°C','相机供电：外部供电DC12-50V','相机接口：通用航插接口','有效像素：1.02亿像素','传感器：IMX461,尺寸43.8*32.9mm','像元尺寸:3.76μm','图像尺寸：11648*8736 px','镜头焦距：50mm/70mm','存储容量：512GB×2','拍照间隔：≥0.85S(JPG格式)','参数调整：支持IS0，白平衡，色彩模式，快门速度等设置修改，支持蓝牙调参','视频尺寸：4K(3860*2610)，30 fps','云台角度：俯仰:-135°至+60°；横滚:-55°~90°；平移:±160°']
      }
    ],
  },
  jgld: {
    text1: '产品中心_任务载荷_激光雷达',
    list: [
      //
      {
        title:'RD1000',
        name:'激光雷达',
        url:'/static/images/v2/jgld/jgld_1.png',
        bg:'/static/images/v2/jgld/jgld_bg1.png',
        info:['重量：2.2kg','系统精度：水平5cm，垂直5cm ','存储容量：256GB','整机功耗：70W','最大扫描距离：1000m','最大发射频率：100万点/秒','最大扫描角度：100°','角度分辨率：0.001°','激光安全等级：Class 1 (人眼安全)','GNSS：持单北斗模式','数据更新频率：500Hz','相机像素：4500万','相机焦距：18mm','适配软件：三维可视化软件，预处理/后处理软件']
      },
      {
        title:'RD1500',
        name:'激光雷达',
        url:'/static/images/v2/jgld/jgld_2.png',
        bg:'/static/images/v2/jgld/jgld_bg2.png',
        info:['重量：3.9kg','系统精度：水平5cm，垂直5cm ','存储容量：256GB','整机功耗：75W','最大扫描距离：1500m','最大发射频率：200万点/秒','最大扫描角度：75°','角度分辨率：0.00015°','激光安全等级：Class 1 (人眼安全)','GNSS：持单北斗模式','数据更新频率：600Hz','相机像素：4500万','相机焦距：18mm','适配软件：三维可视化软件，预处理/后处理软件']
      },
    ],
  },
  dmsb:{
    text1:'产品中心_地面设备',
    text2:'ZT-T30便携操控站',
    text3:' ZT-T30是一款支持单人手持操控无人机的地面移动操控终端，该便携地面站将地面站、数据中转和吊舱触控显示屏高度集成，重量1.5kg，内置电池工作时间4小时，有效提升飞手操控效率和使用体验。',
    text4:' 技术参数',
    text5:'ZT-TG2双屏操控站',
    text6:'ZT-TG2是一款采用折叠双屏设计的无人机地面操控终端，可同时显示视频图像、飞行数据和飞机航线，双屏画面可随时切换，大幅提升无人机操控效率',
    text7:'技术参数',
    text8:'漫游数据链',
    text9:'针对长距离巡逻、城市巡查等领域，远度科技推出了无人机漫游调度系统，创新采用基站协同调度技术，实时收集基站信号质量、链路状态、丢包率等信息并综合分析，实现基站快速精准的动态调度与切换。该系统已成功应用于无人机城市漫游巡逻项目，为多架无人机打造低延时、稳定可靠的通信链路，能适应复杂环境，为行业应用提供坚实通信保障。',
    text10:'中继数据链',
    text11:'无人机中继通信系统创新采用智能信号优化技术，实时收集关键信号信息并深度分析，精准增强与优化信号，为无人机搭建稳定高效数据链路，保障50\n' +
      '            -\n' +
      '            100公里甚至更远距离的通信。在高楼林立的城市及地形多变的山区等复杂环境中，该系统能避开干扰与遮挡，确保信号畅通。该系统能让操作人员解放双手，实现多任务协同，大幅提升作业效率，为各类无人机稳定运行与高效作业提供坚实保障\n' +
      '            。目前，该系统已成功应用于电力巡检、山区测绘等应用场景。',
    padList: [
      {
        name: '轻巧易携',
        text: '该便携地面站仅重1.5kg，飞手操控，轻巧易携'
      },
      {
        name: '功能全面',
        text: '支持多种任务设计模式，功能全面，上手简单'
      },
      {
        name: '持久续航',
        text: '内置电池使用时间超4小时，续航持久，任务无忧'
      },
      {
        name: '高清视频',
        text: '支持1920×1080高清视频，画面清晰流畅'
      },
      {
        name: '实时直播',
        text: '无人机视频画面可实时直播，随时随地观看'
      },
    ],
    pcList: [
      {
        name: '双屏画面',
        text: '采用双屏高清显示大屏，大幅提升无人机操控效率'
      },
      {
        name: '折叠设计',
        text: '采用箱式折叠设计，便于运输与操作'
      },
      {
        name: '功能全面',
        text: '支持多种任务设计模式，功能全面，上手简单'
      },
      {
        name: '性能强大',
        text: '采用XX处理器，32GRAM+1T存储空间，性能强大'
      },
      {
        name: '持久续航',
        text: '内置电池使用时间超4小时，续航持久，任务无忧'
      },
      {
        name: '高清视频',
        text: '支持1920×1080高清视频，画面清晰流畅'
      },
      {
        name: '实时直播',
        text: '无人机视频画面可实时直播，随时随地观看'
      },
    ],
    padParams: [
      {
        name: '外形尺寸',
        text: '340*195*105mm\n' +
          '（±5mm）（长*宽*高）'
      },
      {
        name: '屏幕尺寸',
        text: '10.1寸'
      },
      {
        name: '屏幕分辨率',
        text: '1920 * 1200'
      },
      {
        name: '充电供电',
        text: '（20V/3.25A）65W'
      },
      {
        name: '充电电源',
        text: '单相220V±10%/50Hz'
      },
      {
        name: '重量',
        text: '≤3kg'
      },
      {
        name: '续航时间',
        text: '≥4小时'
      },
      {
        name: '内存',
        text: '8G'
      },
      {
        name: '储存',
        text: '64G'
      },
    ],
    pcParams: [
      {
        name: '外形尺寸',
        text: '413*330*100mm'
      },
      {
        name: '屏幕尺寸',
        text: '15.6寸 * 2'
      },
      {
        name: '屏幕分辨率',
        text: '1920 * 1200'
      },
      {
        name: '键盘',
        text: '86键+快捷键+触控板+摇杆'
      },
      {
        name: '充电电源',
        text: '单相220V±10%/50Hz'
      },
      {
        name: '重量',
        text: '≤10kg（总体重量）'
      },
      {
        name: '续航时间',
        text: '≥4小时'
      },
      {
        name: '内存',
        text: '32G'
      },
      {
        name: '储存',
        text: '1T'
      },
    ],
    meshList: [
      {
        title: '电动无人机地面中继',
        name: 'RSM02',
        position:0,
        urls:['/static/images/v2/dmsb/rsm02_1.png','/static/images/v2/dmsb/rsm02_2.png'],
        text:' \n' +
          '发射功率：双通道 2*2W\n' +
          '工作频段：L波段，135MHz～1450MHz\n' +
          '信道带宽：1/5/10/20MHz（可配）\n' +
          '组网功能：3跳8节点\n' +
          '通信距离：65km（50+km）',
      },
      {
        title: '油电混动无人机地面中继',
        name: 'RSM10',
        position:0,
        urls:['/static/images/v2/dmsb/rsm10_1.png','/static/images/v2/dmsb/rsm10_2.png'],
        text:' \n' +'发射功率：双通道 2*10W\n' +
          '工作频段： L波段，135MHz～1450MHz\n' +
          '信道带宽：1/5/10/20MHz（可配）\n' +
          '通信距离：120km（100+km）',
      },
      {
        title: '地面跟踪天线中继',
        name: 'TAM10',
        position:0,
        urls:['/static/images/v2/dmsb/tam10_1.png','/static/images/v2/dmsb/tam10_2.png','/static/images/v2/dmsb/tam10_3.png'],
        text:' \n' +'发射功率：双通道 2*10W\n' +
          '工作频段：L波段，135MHz～1450MHz\n' +
          '信道带宽：1/5/10/20MHz（可配）\n' +
          '组网功能：3跳8节点\n' +
          '通信距离：200km',
      },
    ]
  },
  rjcp:{
    text1:'产品中心_软件产品',
    list: [
      //
      {
        title: '巡检助手',
        name: '',
        url: '/static/images/v2/rjcp/rj_img1.png',
        bg: '/static/images/v2/jgld/jgld_bg1.png',
        info: ['巡检助手是一款专门适用于远度科技无人机控制地面站的软件应用，集无人机任务规划、实时飞行数据监控、实时视频监控、各类载荷操作、任务高程精细数据检查等功能于一，操作界面简洁易用，有效提升无人机操控效率和使用体验。'],
        ts:['支持航点飞行、多边飞行等多种任务航线规划','支持点线面、kml、点云等地图多元素添加','支持地形高程预警和航线安全检查','支持多机连接与智能控制'],
      },
      {
        title: 'Dowell',
        name: '',
        url: '/static/images/v2/rjcp/rj_img2.png',
        bg: '/static/images/v2/jgld/jgld_bg2.png',
        info: ['Dowell是一款适用于远度科技无人机便携式地面站的软件应用，软件界面简洁，功能内容全面，具有图传数据整合、任务航线规划、实时视频监控、多机控制、AB点起降等诸多功能。'],
        ts:['搭载云巡直播服务，实时视频可同步直播','支持多机控制，具备A-B异地起降功能','具备数据回放功能','界面简洁操作便捷'],
      },
      {
        title: '云巡',
        name: '',
        url: '/static/images/v2/rjcp/rj_img3.png',
        bg: '/static/images/v2/jgld/jgld_bg2.png',
        info: ['云巡是一款无人机远程控制与管理软件，可对飞行任务进行精细化分类，实现精准和高效管理。该平台可实现信息互通共享，通过公网或专网将无人机飞行数据进行可视化展示与智能分析，形成一站式服务链条，为用户科学决策提供关键支持。'],
        ts:['多模式多形态，实时动态展示无人机状态','实时远程监控与管理，无人机状态随时掌控','支持多平台、多用户同步查看与管理','具备数据回放功能'],
      },
    ],
  },
  fzxt:{
    text1:'仿真飞行培训系统',
    text2:'仿真飞行培训系统，传感器数据采用半实物仿真框架，可实现多款飞机在各类飞行场景的飞行训练，且最大限度的接近真实飞机作业，如海岛边防巡检、电网通道巡检、森林防火巡检等，实现全场景的3D实景效果，全面提升了飞手实飞操控熟练手感，率先熟悉各个领域的飞行作业细节，减少日常训练的损失。',
    text3:'高度集成，快速搭建',
    text4:'摒弃传统飞行模拟器冗杂结构，重新高度集成,使得用户获得完整真实的飞行模拟练习。',
    text5:'更真实的飞行体验',
    text6:'采用半实物仿真框架，传感器数据和碰撞效果等完全由物理引擎实时模拟，系统上层逻辑应用和真实无人机完全一致。',
    text7:'仿真飞行培训系统',
    text8:'包含整套航电,灵活部署',
    text9:'(需要额外的电脑)',
    text10:'仿真飞行培训系统',
    text11:'集成化程度高,开机即用',
    text12:'3D全景设计，效果逼真',
    text13:'UE5动画渲染图像，3D实景模拟，环境更逼真，吊舱视角、第三视角、顶视角等多视角体验，支持导入场景数据进行模拟，给予客户更真实的飞行体验和震撼的视觉效果。',
    text14:'多款机型切换，实战演练',
    text15:'1:1还原真实无人机在实飞作业中的状态，控制响应与真机一样，高度还原实战状态，并支持多款复合翼、多旋翼、无人直升机等不同机型的模拟切换。',
    text16:'丰富的场景、功能选择，全领域覆盖',
    text17:'丰富的场景选择，海岛边防巡检、电网通道巡检、消防应急巡视、火场救援侦察、城市安防巡检等多领域多场景体验，并支持场景定制，全领域覆盖。',
    list:[
      {
        name:'支持气象条件叠加，模拟故障',
        text:'仿真系统可以模拟传感器设置突发故障条件，以及设置风力风向雨雪等气象条件，将真实的气象环境叠加到模拟器中，锻炼并提升飞手的飞行经验。',
        url:'/static/images/v2/fzxt/fz_list2.png',
      },
      {
        name:'支持集群飞行，训练更加全面',
        text:'多台飞机在同一场景可以进行集群协同作业，实现虚拟状态下复杂环境的高效和智能作业，使侦察训练更加全面和精准。',
        url:'/static/images/v2/fzxt/fz_list3.png',
      },
      {
        name:'支持作业标注与多项检查',
        text:'在定制化的场景中可以对异常电塔、火点、搜救人员进行标注，并对飞机的航线、电机舵机和起飞等进行检查与评估，并反馈是否正确。',
        url:'/static/images/v2/fzxt/fz_list4.png',
      }
    ]
  },
  yxxt:{
    text1:'云巡无人值守系统',
    text2:'云巡无人值守系统由ZT-13V垂直起降固定翼无人机和AH13垂直起降固定翼无人机自动机场组成，具备智能化、自动化、高效化、精准化的优势特点。该系统具备复合翼无人机智能存储、远程控制、自主起降、智能作业、自动回收、自动充电、数据回传、智能分析等功能，可实现无人机自主化、全流程、无人值守作业。该系统采用的ZT-13V复合翼无人机，单架次有效飞行时长200分钟，最大巡检长度为180公里。该系统可广泛应用于铁路、电力、管线、矿山、林草、应急、边防、海事、智慧城市等行业。',
    text3:'技术参数',
    list:[
      {
        icon:'/static/images/v2/120v/120v_icon1.png',
        title:'VTOL',
        info:'四旋翼+固定翼复合气动布局。既有垂直起降便利，又具备固定翼长航时的特点，续航时间达10小时。'
      },{
        icon:'/static/images/v2/120v/120v_icon2.png',
        title:'模块化设计',
        info:'机身、机翼、任务载荷均为模块化设计，“免工具”拆装，可快速完成组装部署。'
      },{
        icon:'/static/images/v2/120v/120v_icon3.png',
        title:'自组网数据链',
        info:'标配50——100km自组网数据链，无人机支持 “机-机中继”技术，传输距离可扩展至300km+。'
      },{
        icon:'/static/images/v2/120v/120v_icon4.png',
        title:'抗反制抗干扰',
        info:'专有传感器+闭环姿态算法，可在卫星信号受到干扰或诱骗环境下拒止环境下保持安全飞行。'
      }
    ],
    paramsList: [
      {
        title: "尺寸",
        info:'长3.9*宽2.19*高1.6m'
      }, {
        title: "重量",
        info:'≤1000kg（不包含航空器）'
      },{
        title: "放行/回收时间",
        info:'≤5min'
      },{
        title: "输入电源",
        info:'220V 50Hz'
      },{
        title: "备用电源",
        info:'≥4h+1次回收'
      },{
        title: "防护等级",
        info:'IP55，允许对机库外壳维护清洗'
      },
    ]
  },
  hyxw:{
    text1:'新闻动态',
    text2:'...查看全文',
    list: [
      {
        title:'航翊科技多款明星成熟装备亮相珠海航展，收获近亿元意向订单！',
        text:'第十五届中国国际航天航空博览会，于2024年11月12日-11月17日在珠海国际航展中心举行，这场受到全球瞩目的“蓝天盛会”，共吸引来自47个国家和地区的1022家企业参展，其中境外展商较上届航展翻倍。中国国际航空航天博览会是唯一由国务院批准的大型国际航展...',
        time:'2024/11/15',
        img:'/static/images/v2/hyxw/xw1.png',
        path:'',
      },
      {
        title:'中国航展 | 航翊科技邀您共赴珠海航展，共享低空经济发展未来',
        text:'航翊科技邀您共赴珠海航展共享低空经济发展未来.',
        time:'2024/11/08',
        img:'/static/images/v2/hyxw/xw2.png',
        path:'',
      },
      {
        title:'四川航翊智云无人直升机亮相2024自贡低空经济发展大会',
        text:'11月1日，由四川省委军民融合办、省经济和信息化厅与自贡市人民政府联合举办的“2024自贡低空经济发展大会”在四川自贡航空产业园举行。此次活动由四川省委军民融合办、四川省经济和信息化厅与自贡市人民政府共同举办。四川省人民政府副省长田庆盈出席会议并致...',
        time:'2024/11/05',
        img:'/static/images/v2/hyxw/xw3.png',
        path:'',
      },
      {
        title:'HW-600H无人直升机参加全国森林草原防灭火新质能力建设实战演练！',
        text:'10月31日，全国森林草原防灭火新质能力建设实战演练成功举办。本次实战演练由国家森林草原防灭火指挥部办公室主办，广东省森林防灭火指挥部办公室、广州市人民政府等单位承办。本次实战演练旨在检验预案，锻炼队伍，磨合机制，强化协同作战能力。航翊科技应...',
        time:'2024/11/04',
        img:'/static/images/v2/hyxw/xw4.png',
        path:'',
      },
      {
        title:'实战砺剑 | 航翊科技HW-600H无人直升机“三断”超视距物资投送能力验证“精准送达“！',
        text:'日前， “三断”情况下无人机物资投送能力测试活动在山东莱芜举行，航翊科技应邀参加本次活动。在“三断”情况下超视距物资运输测试中，航翊科技旗下HW-600H无人直升机是唯一完成载重100kg以上级别测试的机型，整个测试HW-600H表现出色圆满完赛，获得现场领...',
        time:'2024/08/27',
        img:'/static/images/v2/hyxw/xw5.png',
        path:'',
      },
      {
        title:'【政策解读】无人机出口管制措施，航翊科技再获“两用物项和技术出口许可证”！',
        text:'2024年7月31日，商务部、海关总署、中央军委装备发展部联合发布了优化调整无人机出口管制措施的公告，新政策于2024年9月1日起正式施行。相较于2023年第27号和第28号公告，此次调整主要包括以下几个方面变化...',
        time:'2024/08/01',
        img:'/static/images/v2/hyxw/xw6.png',
        path:'',
      }
    ],
  },
  join:{
    text1:'公司简介',
    text2:'航翊科技专注于大载重无人直升机与垂直起降固定翼无人机的研发与生产，致力于为客户提供专业的无人机系统解决方案。公司创始团队从事无人机行业数十年，拥有一系列自主知识产权，掌握飞行控制系统、光电吊舱、远程数据链、Al\n' +
      '          机器视觉等无人机核心关键技术，具备无人机全产业链的自主研发和生产制造能力。',
    text3:'航翊科技在北京延庆、四川自贡已实现两地三中心建设，打造集研发、生产、测试、销售、服务、培训为一体的全产业链化基地，全面\n' +
      '          布局无人直升机、无人机专用航电、复合翼无人机、智能灭火弹等系列产品，产品广泛应用于军工、警务、应急、电力、边防、石油等多个领域，远销海外。',
    text4:'航翊科技总部',
    text5:'四川自贡生产基地',
    text6:'北京延庆生产基地',
    list: [
      {
        name: '全产业链',
        text: '工业级特种无人机赛道唯一完整掌握飞控、数据链、 光电吊舱、计算机视觉等全产业链关键技术的团队。'
      },
      {
        name: '全领域',
        text: '公司产品可适配全领域载荷，广泛应用于应急、消防、边防、电力、石油、勘探、军工等众多领域。'
      },
      {
        name: '18年+',
        text: '核心团队源于清华，专研飞控、云台等核心技术18年以上，经过上千次算法迭代以及数十万台产品市场考验。'
      },
      {
        name: '自主可控',
        text: '具备自主研发和生产制造能力，形成全面的硬件和软件产品体系，工业无人机核心技术自主可控。'
      }
    ],
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js